export type DataObject = {
  [key: number]: number;
};

// **セットAのデータ**
export const dataA: DataObject = {
  1400: 9747,
  1399: 9741,
  1398: 9734,
  1397: 9728,
  1396: 9722,
  1395: 9716,
  1394: 9709,
  1393: 9703,
  1392: 9697,
  1391: 9690,
  1390: 9684,
  1389: 9678,
  1388: 9671,
  1387: 9665,
  1386: 9659,
  1385: 9652,
  1384: 9646,
  1383: 9640,
  1382: 9633,
  1381: 9627,
  1380: 9621,
  1379: 9614,
  1378: 9608,
  1377: 9602,
  1376: 9595,
  1375: 9589,
  1374: 9583,
  1373: 9576,
  1372: 9570,
  1371: 9564,
  1370: 9557,
  1369: 9551,
  1368: 9545,
  1367: 9538,
  1366: 9532,
  1365: 9526,
  1364: 9519,
  1363: 9513,
  1362: 9507,
  1361: 9500,
  1360: 9494,
  1359: 9488,
  1358: 9481,
  1357: 9475,
  1356: 9468,
  1355: 9462,
  1354: 9456,
  1353: 9449,
  1352: 9443,
  1351: 9437,
  1350: 9430,
  1349: 9424,
  1348: 9418,
  1347: 9411,
  1346: 9405,
  1345: 9399,
  1344: 9392,
  1343: 9386,
  1342: 9380,
  1341: 9373,
  1340: 9367,
  1339: 9361,
  1338: 9354,
  1337: 9348,
  1336: 9342,
  1335: 9335,
  1334: 9329,
  1333: 9322,
  1332: 9316,
  1331: 9310,
  1330: 9303,
  1329: 9297,
  1328: 9291,
  1327: 9284,
  1326: 9278,
  1325: 9272,
  1324: 9265,
  1323: 9259,
  1322: 9253,
  1321: 9246,
  1320: 9240,
  1319: 9233,
  1318: 9227,
  1317: 9221,
  1316: 9214,
  1315: 9208,
  1314: 9202,
  1313: 9195,
  1312: 9189,
  1311: 9183,
  1310: 9176,
  1309: 9170,
  1308: 9163,
  1307: 9157,
  1306: 9151,
  1305: 9144,
  1304: 9138,
  1303: 9132,
  1302: 9125,
  1301: 9119,
  1300: 9112,
  1299: 9106,
  1298: 9100,
  1297: 9093,
  1296: 9087,
  1295: 9081,
  1294: 9074,
  1293: 9068,
  1292: 9061,
  1291: 9055,
  1290: 9049,
  1289: 9042,
  1288: 9036,
  1287: 9030,
  1286: 9023,
  1285: 9017,
  1284: 9010,
  1283: 9004,
  1282: 8998,
  1281: 8991,
  1280: 8985,
  1279: 8979,
  1278: 8972,
  1277: 8966,
  1276: 8959,
  1275: 8953,
  1274: 8947,
  1273: 8940,
  1272: 8934,
  1271: 8927,
  1270: 8921,
  1269: 8915,
  1268: 8908,
  1267: 8902,
  1266: 8896,
  1265: 8889,
  1264: 8883,
  1263: 8876,
  1262: 8870,
  1261: 8864,
  1260: 8857,
  1259: 8851,
  1258: 8844,
  1257: 8838,
  1256: 8832,
  1255: 8825,
  1254: 8819,
  1253: 8812,
  1252: 8806,
  1251: 8800,
  1250: 8793,
  1249: 8787,
  1248: 8780,
  1247: 8774,
  1246: 8768,
  1245: 8761,
  1244: 8755,
  1243: 8748,
  1242: 8742,
  1241: 8736,
  1240: 8729,
  1239: 8723,
  1238: 8716,
  1237: 8710,
  1236: 8704,
  1235: 8697,
  1234: 8691,
  1233: 8684,
  1232: 8678,
  1231: 8672,
  1230: 8665,
  1229: 8659,
  1228: 8652,
  1227: 8646,
  1226: 8640,
  1225: 8633,
  1224: 8627,
  1223: 8620,
  1222: 8614,
  1221: 8607,
  1220: 8601,
  1219: 8595,
  1218: 8588,
  1217: 8582,
  1216: 8575,
  1215: 8569,
  1214: 8563,
  1213: 8556,
  1212: 8550,
  1211: 8543,
  1210: 8537,
  1209: 8530,
  1208: 8524,
  1207: 8518,
  1206: 8511,
  1205: 8505,
  1204: 8498,
  1203: 8492,
  1202: 8486,
  1201: 8479,
  1200: 8473,
  1199: 8466,
  1198: 8460,
  1197: 8453,
  1196: 8447,
  1195: 8441,
  1194: 8434,
  1193: 8428,
  1192: 8421,
  1191: 8415,
  1190: 8408,
  1189: 8402,
  1188: 8396,
  1187: 8389,
  1186: 8383,
  1185: 8376,
  1184: 8370,
  1183: 8363,
  1182: 8357,
  1181: 8351,
  1180: 8344,
  1179: 8338,
  1178: 8331,
  1177: 8325,
  1176: 8318,
  1175: 8312,
  1174: 8306,
  1173: 8299,
  1172: 8293,
  1171: 8286,
  1170: 8280,
  1169: 8273,
  1168: 8267,
  1167: 8260,
  1166: 8254,
  1165: 8248,
  1164: 8241,
  1163: 8235,
  1162: 8228,
  1161: 8222,
  1160: 8215,
  1159: 8209,
  1158: 8202,
  1157: 8196,
  1156: 8190,
  1155: 8183,
  1154: 8177,
  1153: 8170,
  1152: 8164,
  1151: 8157,
  1150: 8151,
  1149: 8144,
  1148: 8138,
  1147: 8132,
  1146: 8125,
  1145: 8119,
  1144: 8112,
  1143: 8106,
  1142: 8099,
  1141: 8093,
  1140: 8086,
  1139: 8080,
  1138: 8073,
  1137: 8067,
  1136: 8061,
  1135: 8054,
  1134: 8048,
  1133: 8041,
  1132: 8035,
  1131: 8028,
  1130: 8022,
  1129: 8015,
  1128: 8009,
  1127: 8002,
  1126: 7996,
  1125: 7990,
  1124: 7983,
  1123: 7977,
  1122: 7970,
  1121: 7964,
  1120: 7957,
  1119: 7951,
  1118: 7944,
  1117: 7938,
  1116: 7931,
  1115: 7925,
  1114: 7918,
  1113: 7912,
  1112: 7905,
  1111: 7899,
  1110: 7893,
  1109: 7886,
  1108: 7880,
  1107: 7873,
  1106: 7867,
  1105: 7860,
  1104: 7854,
  1103: 7847,
  1102: 7841,
  1101: 7834,
  1100: 7828,
  1099: 7821,
  1098: 7815,
  1097: 7808,
  1096: 7802,
  1095: 7795,
  1094: 7789,
  1093: 7782,
  1092: 7776,
  1091: 7770,
  1090: 7763,
  1089: 7757,
  1088: 7750,
  1087: 7744,
  1086: 7737,
  1085: 7731,
  1084: 7724,
  1083: 7718,
  1082: 7711,
  1081: 7705,
  1080: 7698,
  1079: 7692,
  1078: 7685,
  1077: 7679,
  1076: 7672,
  1075: 7666,
  1074: 7659,
  1073: 7653,
  1072: 7646,
  1071: 7640,
  1070: 7633,
  1069: 7627,
  1068: 7620,
  1067: 7614,
  1066: 7607,
  1065: 7601,
  1064: 7594,
  1063: 7588,
  1062: 7581,
  1061: 7575,
  1060: 7568,
  1059: 7562,
  1058: 7555,
  1057: 7549,
  1056: 7542,
  1055: 7536,
  1054: 7529,
  1053: 7523,
  1052: 7516,
  1051: 7510,
  1050: 7503,
  1049: 7497,
  1048: 7490,
  1047: 7484,
  1046: 7477,
  1045: 7471,
  1044: 7464,
  1043: 7458,
  1042: 7451,
  1041: 7445,
  1040: 7438,
  1039: 7432,
  1038: 7425,
  1037: 7419,
  1036: 7412,
  1035: 7406,
  1034: 7399,
  1033: 7393,
  1032: 7386,
  1031: 7380,
  1030: 7373,
  1029: 7367,
  1028: 7360,
  1027: 7354,
  1026: 7347,
  1025: 7341,
  1024: 7334,
  1023: 7328,
  1022: 7321,
  1021: 7315,
  1020: 7308,
  1019: 7302,
  1018: 7295,
  1017: 7288,
  1016: 7282,
  1015: 7275,
  1014: 7269,
  1013: 7262,
  1012: 7256,
  1011: 7249,
  1010: 7243,
  1009: 7236,
  1008: 7230,
  1007: 7223,
  1006: 7217,
  1005: 7210,
  1004: 7204,
  1003: 7197,
  1002: 7191,
  1001: 7184,
  1000: 7178,
  999: 7171,
  998: 7165,
  997: 7158,
  996: 7151,
  995: 7145,
  994: 7138,
  993: 7132,
  992: 7125,
  991: 7119,
  990: 7112,
  989: 7106,
  988: 7099,
  987: 7093,
  986: 7086,
  985: 7080,
  984: 7073,
  983: 7067,
  982: 7060,
  981: 7053,
  980: 7047,
  979: 7040,
  978: 7034,
  977: 7027,
  976: 7021,
  975: 7014,
  974: 7008,
  973: 7001,
  972: 6995,
  971: 6988,
  970: 6981,
  969: 6975,
  968: 6968,
  967: 6962,
  966: 6955,
  965: 6949,
  964: 6942,
  963: 6936,
  962: 6929,
  961: 6923,
  960: 6916,
  959: 6909,
  958: 6903,
  957: 6896,
  956: 6890,
  955: 6883,
  954: 6877,
  953: 6870,
  952: 6864,
  951: 6857,
  950: 6850,
  949: 6844,
  948: 6837,
  947: 6831,
  946: 6824,
  945: 6818,
  944: 6811,
  943: 6805,
  942: 6798,
  941: 6791,
  940: 6785,
  939: 6778,
  938: 6772,
  937: 6765,
  936: 6759,
  935: 6752,
  934: 6745,
  933: 6739,
  932: 6732,
  931: 6726,
  930: 6719,
  929: 6713,
  928: 6706,
  927: 6699,
  926: 6693,
  925: 6686,
  924: 6680,
  923: 6673,
  922: 6667,
  921: 6660,
  920: 6653,
  919: 6647,
  918: 6640,
  917: 6634,
  916: 6627,
  915: 6621,
  914: 6614,
  913: 6607,
  912: 6601,
  911: 6594,
  910: 6588,
  909: 6581,
  908: 6575,
  907: 6568,
  906: 6561,
  905: 6555,
  904: 6548,
  903: 6542,
  902: 6535,
  901: 6529,
  900: 6522,
  899: 6515,
  898: 6509,
  897: 6502,
  896: 6496,
  895: 6489,
  894: 6482,
  893: 6476,
  892: 6469,
  891: 6463,
  890: 6456,
  889: 6449,
  888: 6443,
  887: 6436,
  886: 6430,
  885: 6423,
  884: 6417,
  883: 6410,
  882: 6403,
  881: 6397,
  880: 6390,
  879: 6384,
  878: 6377,
  877: 6370,
  876: 6364,
  875: 6357,
  874: 6351,
  873: 6344,
  872: 6337,
  871: 6331,
  870: 6324,
  869: 6318,
  868: 6311,
  867: 6304,
  866: 6298,
  865: 6291,
  864: 6285,
  863: 6278,
  862: 6271,
  861: 6265,
  860: 6258,
  859: 6251,
  858: 6245,
  857: 6238,
  856: 6232,
  855: 6225,
  854: 6218,
  853: 6212,
  852: 6205,
  851: 6199,
  850: 6192,
  849: 6185,
  848: 6179,
  847: 6172,
  846: 6166,
  845: 6159,
  844: 6152,
  843: 6146,
  842: 6139,
  841: 6132,
  840: 6126,
  839: 6119,
  838: 6113,
  837: 6106,
  836: 6099,
  835: 6093,
  834: 6086,
  833: 6080,
  832: 6073,
  831: 6066,
  830: 6060,
  829: 6053,
  828: 6046,
  827: 6040,
  826: 6033,
  825: 6027,
  824: 6020,
  823: 6013,
  822: 6007,
  821: 6000,
  820: 5993,
  819: 5987,
  818: 5980,
  817: 5973,
  816: 5967,
  815: 5960,
  814: 5954,
  813: 5947,
  812: 5940,
  811: 5934,
  810: 5927,
  809: 5920,
  808: 5914,
  807: 5907,
  806: 5901,
  805: 5894,
  804: 5887,
  803: 5881,
  802: 5874,
  801: 5867,
  800: 5861,
  799: 5854,
  798: 5847,
  797: 5841,
  796: 5834,
  795: 5827,
  794: 5821,
  793: 5814,
  792: 5808,
  791: 5801,
  790: 5794,
  789: 5788,
  788: 5781,
  787: 5774,
  786: 5768,
  785: 5761,
  784: 5754,
  783: 5748,
  782: 5741,
  781: 5734,
  780: 5728,
  779: 5721,
  778: 5714,
  777: 5708,
  776: 5701,
  775: 5694,
  774: 5688,
  773: 5681,
  772: 5675,
  771: 5668,
  770: 5661,
  769: 5655,
  768: 5648,
  767: 5641,
  766: 5635,
  765: 5628,
  764: 5621,
  763: 5615,
  762: 5608,
  761: 5601,
  760: 5595,
  759: 5588,
  758: 5581,
  757: 5575,
  756: 5568,
  755: 5561,
  754: 5555,
  753: 5548,
  752: 5541,
  751: 5535,
  750: 5528,
  749: 5521,
  748: 5515,
  747: 5508,
  746: 5501,
  745: 5495,
  744: 5488,
  743: 5481,
  742: 5475,
  741: 5468,
  740: 5461,
  739: 5455,
  738: 5448,
  737: 5441,
  736: 5434,
  735: 5428,
  734: 5421,
  733: 5414,
  732: 5408,
  731: 5401,
  730: 5394,
  729: 5388,
  728: 5381,
  727: 5374,
  726: 5368,
  725: 5361,
  724: 5354,
  723: 5348,
  722: 5341,
  721: 5334,
  720: 5328,
  719: 5321,
  718: 5314,
  717: 5308,
  716: 5301,
  715: 5294,
  714: 5287,
  713: 5281,
  712: 5274,
  711: 5267,
  710: 5261,
  709: 5254,
  708: 5247,
  707: 5241,
  706: 5234,
  705: 5227,
  704: 5221,
  703: 5214,
  702: 5207,
  701: 5200,
  700: 5194,
  699: 5187,
  698: 5180,
  697: 5174,
  696: 5167,
  695: 5160,
  694: 5154,
  693: 5147,
  692: 5140,
  691: 5133,
  690: 5127,
  689: 5120,
  688: 5113,
  687: 5107,
  686: 5100,
  685: 5093,
  684: 5086,
  683: 5080,
  682: 5073,
  681: 5066,
  680: 5060,
  679: 5053,
  678: 5046,
  677: 5039,
  676: 5033,
  675: 5026,
  674: 5019,
  673: 5013,
  672: 5006,
  671: 4999,
  670: 4992,
  669: 4986,
  668: 4979,
  667: 4972,
  666: 4966,
  665: 4959,
  664: 4952,
  663: 4945,
  662: 4939,
  661: 4932,
  660: 4925,
  659: 4919,
  658: 4912,
  657: 4905,
  656: 4898,
  655: 4892,
  654: 4885,
  653: 4878,
  652: 4871,
  651: 4865,
  650: 4858,
  649: 4851,
  648: 4845,
  647: 4838,
  646: 4831,
  645: 4824,
  644: 4818,
  643: 4811,
  642: 4804,
  641: 4797,
  640: 4791,
  639: 4784,
  638: 4777,
  637: 4771,
  636: 4764,
  635: 4757,
  634: 4750,
  633: 4744,
  632: 4737,
  631: 4730,
  630: 4723,
  629: 4717,
  628: 4710,
  627: 4703,
  626: 4696,
  625: 4690,
  624: 4683,
  623: 4676,
  622: 4669,
  621: 4663,
  620: 4656,
  619: 4649,
  618: 4642,
  617: 4636,
  616: 4629,
  615: 4622,
  614: 4615,
  613: 4609,
  612: 4602,
  611: 4595,
  610: 4588,
  609: 4582,
  608: 4575,
  607: 4568,
  606: 4561,
  605: 4555,
  604: 4548,
  603: 4541,
  602: 4534,
  601: 4528,
  600: 4521,
  599: 4514,
  598: 4507,
  597: 4501,
  596: 4494,
  595: 4487,
  594: 4480,
  593: 4474,
  592: 4467,
  591: 4460,
  590: 4453,
  589: 4446,
  588: 4440,
  587: 4433,
  586: 4426,
  585: 4419,
  584: 4413,
  583: 4406,
  582: 4399,
  581: 4392,
  580: 4386,
  579: 4379,
  578: 4372,
  577: 4365,
  576: 4358,
  575: 4352,
  574: 4345,
  573: 4338,
  572: 4331,
  571: 4325,
  570: 4318,
  569: 4311,
  568: 4304,
  567: 4298,
  566: 4291,
  565: 4284,
  564: 4277,
  563: 4270,
  562: 4264,
  561: 4257,
  560: 4250,
  559: 4243,
  558: 4236,
  557: 4230,
  556: 4223,
  555: 4216,
  554: 4209,
  553: 4203,
  552: 4196,
  551: 4189,
  550: 4182,
  549: 4175,
  548: 4169,
  547: 4162,
  546: 4155,
  545: 4148,
  544: 4141,
  543: 4135,
  542: 4128,
  541: 4121,
  540: 4114,
  539: 4107,
  538: 4101,
  537: 4094,
  536: 4087,
  535: 4080,
  534: 4073,
  533: 4067,
  532: 4060,
  531: 4053,
  530: 4046,
  529: 4039,
  528: 4033,
  527: 4026,
  526: 4019,
  525: 4012,
  524: 4005,
  523: 3999,
  522: 3992,
  521: 3985,
  520: 3978,
  519: 3971,
  518: 3965,
  517: 3958,
  516: 3951,
  515: 3944,
  514: 3937,
  513: 3931,
  512: 3924,
  511: 3917,
  510: 3910,
  509: 3903,
  508: 3897,
  507: 3890,
  506: 3883,
  505: 3876,
  504: 3869,
  503: 3862,
  502: 3856,
  501: 3849,
  500: 3842,
  499: 3835,
  498: 3828,
  497: 3822,
  496: 3815,
  495: 3808,
  494: 3801,
  493: 3794,
  492: 3787,
  491: 3781,
  490: 3774,
  489: 3767,
  488: 3760,
  487: 3753,
  486: 3746,
  485: 3740,
  484: 3733,
  483: 3726,
  482: 3719,
  481: 3712,
  480: 3705,
  479: 3699,
  478: 3692,
  477: 3685,
  476: 3678,
  475: 3671,
  474: 3664,
  473: 3658,
  472: 3651,
  471: 3644,
  470: 3637,
  469: 3630,
  468: 3623,
  467: 3617,
  466: 3610,
  465: 3603,
  464: 3596,
  463: 3589,
  462: 3582,
  461: 3576,
  460: 3569,
  459: 3562,
  458: 3555,
  457: 3548,
  456: 3541,
  455: 3534,
  454: 3528,
  453: 3521,
  452: 3514,
  451: 3507,
  450: 3500,
  449: 3493,
  448: 3487,
  447: 3480,
  446: 3473,
  445: 3466,
  444: 3459,
  443: 3452,
  442: 3445,
  441: 3439,
  440: 3432,
  439: 3425,
  438: 3418,
  437: 3411,
  436: 3404,
  435: 3397,
  434: 3391,
  433: 3384,
  432: 3377,
  431: 3370,
  430: 3363,
  429: 3356,
  428: 3349,
  427: 3343,
  426: 3336,
  425: 3329,
  424: 3322,
  423: 3315,
  422: 3308,
  421: 3301,
  420: 3294,
  419: 3288,
  418: 3281,
  417: 3274,
  416: 3267,
  415: 3260,
  414: 3253,
  413: 3246,
  412: 3239,
  411: 3233,
  410: 3226,
  409: 3219,
  408: 3212,
  407: 3205,
  406: 3198,
  405: 3191,
  404: 3184,
  403: 3178,
  402: 3171,
  401: 3164,
  400: 3157,
  399: 3150,
  398: 3143,
  397: 3136,
  396: 3129,
  395: 3122,
  394: 3116,
  393: 3109,
  392: 3102,
  391: 3095,
  390: 3088,
  389: 3081,
  388: 3074,
  387: 3067,
  386: 3060,
  385: 3054,
  384: 3047,
  383: 3040,
  382: 3033,
  381: 3026,
  380: 3019,
  379: 3012,
  378: 3005,
  377: 2998,
  376: 2992,
  375: 2985,
  374: 2978,
  373: 2971,
  372: 2964,
  371: 2957,
  370: 2950,
  369: 2943,
  368: 2936,
  367: 2929,
  366: 2923,
  365: 2916,
  364: 2909,
  363: 2902,
  362: 2895,
  361: 2888,
  360: 2881,
  359: 2874,
  358: 2867,
  357: 2860,
  356: 2853,
  355: 2847,
  354: 2840,
  353: 2833,
  352: 2826,
  351: 2819,
  350: 2812,
  349: 2805,
  348: 2798,
  347: 2791,
  346: 2784,
  345: 2777,
  344: 2770,
  343: 2764,
  342: 2757,
  341: 2750,
  340: 2743,
  339: 2736,
  338: 2729,
  337: 2722,
  336: 2715,
  335: 2708,
  334: 2701,
  333: 2694,
  332: 2687,
  331: 2681,
  330: 2674,
  329: 2667,
  328: 2660,
  327: 2653,
  326: 2646,
  325: 2639,
  324: 2632,
  323: 2625,
  322: 2618,
  321: 2611,
  320: 2604,
  319: 2597,
  318: 2590,
  317: 2583,
  316: 2577,
  315: 2570,
  314: 2563,
  313: 2556,
  312: 2549,
  311: 2542,
  310: 2535,
  309: 2528,
  308: 2521,
  307: 2514,
  306: 2507,
  305: 2500,
  304: 2493,
  303: 2486,
  302: 2479,
  301: 2472,
  300: 2465,
  299: 2459,
  298: 2452,
  297: 2445,
  296: 2438,
  295: 2431,
  294: 2424,
  293: 2417,
  292: 2410,
  291: 2403,
  290: 2396,
  289: 2389,
  288: 2382,
  287: 2375,
  286: 2368,
  285: 2361,
  284: 2354,
  283: 2347,
  282: 2340,
  281: 2333,
  280: 2326,
  279: 2319,
  278: 2312,
  277: 2306,
  276: 2299,
  275: 2292,
  274: 2285,
  273: 2278,
  272: 2271,
  271: 2264,
  270: 2257,
  269: 2250,
  268: 2243,
  267: 2236,
  266: 2229,
  265: 2222,
  264: 2215,
  263: 2208,
  262: 2201,
  261: 2194,
  260: 2187,
  259: 2180,
  258: 2173,
  257: 2166,
  256: 2159,
  255: 2152,
  254: 2145,
  253: 2138,
  252: 2131,
  251: 2124,
  250: 2117,
  249: 2110,
  248: 2103,
  247: 2096,
  246: 2089,
  245: 2082,
  244: 2075,
  243: 2068,
  242: 2061,
  241: 2054,
  240: 2047,
  239: 2040,
  238: 2033,
  237: 2026,
  236: 2020,
  235: 2013,
  234: 2006,
  233: 1999,
  232: 1992,
  231: 1985,
  230: 1978,
  229: 1971,
  228: 1964,
  227: 1957,
  226: 1950,
  225: 1943,
  224: 1936,
  223: 1929,
  222: 1922,
  221: 1915,
  220: 1908,
  219: 1901,
  218: 1894,
  217: 1887,
  216: 1880,
  215: 1873,
  214: 1866,
  213: 1859,
  212: 1852,
  211: 1845,
  210: 1838,
  209: 1831,
  208: 1824,
  207: 1817,
  206: 1810,
  205: 1803,
  204: 1796,
  203: 1788,
  202: 1781,
  201: 1774,
  200: 1767,
  199: 1760,
  198: 1753,
  197: 1746,
  196: 1739,
  195: 1732,
  194: 1725,
  193: 1718,
  192: 1711,
  191: 1704,
  190: 1697,
  189: 1690,
  188: 1683,
  187: 1676,
  186: 1669,
  185: 1662,
  184: 1655,
  183: 1648,
  182: 1641,
  181: 1634,
  180: 1627,
  179: 1620,
  178: 1613,
  177: 1606,
  176: 1599,
  175: 1592,
  174: 1585,
  173: 1578,
  172: 1571,
  171: 1564,
  170: 1557,
  169: 1550,
  168: 1543,
  167: 1536,
  166: 1529,
  165: 1522,
  164: 1515,
  163: 1507,
  162: 1500,
  161: 1493,
  160: 1486,
  159: 1479,
  158: 1472,
  157: 1465,
  156: 1458,
  155: 1451,
  154: 1444,
  153: 1437,
  152: 1430,
  151: 1423,
  150: 1416,
  149: 1409,
  148: 1402,
  147: 1395,
  146: 1388,
  145: 1381,
  144: 1374,
  143: 1367,
  142: 1360,
  141: 1352,
  140: 1345,
  139: 1338,
  138: 1331,
  137: 1324,
  136: 1317,
  135: 1310,
  134: 1303,
  133: 1296,
  132: 1289,
  131: 1282,
  130: 1275,
  129: 1268,
  128: 1261,
  127: 1254,
  126: 1247,
  125: 1240,
  124: 1232,
  123: 1225,
  122: 1218,
  121: 1211,
  120: 1204,
  119: 1197,
  118: 1190,
  117: 1183,
  116: 1176,
  115: 1169,
  114: 1162,
  113: 1155,
  112: 1148,
  111: 1141,
  110: 1133,
  109: 1126,
  108: 1119,
  107: 1112,
  106: 1105,
  105: 1098,
  104: 1091,
  103: 1084,
  102: 1077,
  101: 1070,
  100: 1063,
  99: 1056,
  98: 1049,
  97: 1041,
  96: 1034,
  95: 1027,
  94: 1020,
  93: 1013,
  92: 1006,
  91: 999,
  90: 992,
  89: 985,
  88: 978,
  87: 971,
  86: 963,
  85: 956,
  84: 949,
  83: 942,
  82: 935,
  81: 928,
  80: 921,
  79: 914,
  78: 907,
  77: 900,
  76: 893,
  75: 885,
  74: 878,
  73: 871,
  72: 864,
  71: 857,
  70: 850,
  69: 843,
  68: 836,
  67: 829,
  66: 822,
  65: 814,
  64: 807,
  63: 800,
  62: 793,
  61: 786,
  60: 779,
  59: 772,
  58: 765,
  57: 758,
  56: 750,
  55: 743,
  54: 736,
  53: 729,
  52: 722,
  51: 715,
  50: 708,
  49: 701,
  48: 694,
  47: 686,
  46: 679,
  45: 672,
  44: 665,
  43: 658,
  42: 651,
  41: 644,
  40: 637,
  39: 629,
  38: 622,
  37: 615,
  36: 608,
  35: 601,
  34: 594,
  33: 587,
  32: 580,
  31: 572,
  30: 565,
  29: 558,
  28: 551,
  27: 544,
  26: 537,
  25: 530,
  24: 522,
  23: 515,
  22: 508,
  21: 501,
  20: 494,
  19: 487,
  18: 480,
  17: 472,
  16: 465,
  15: 458,
  14: 451,
  13: 444,
  12: 437,
  11: 430,
  10: 423,
  9: 415,
  8: 408,
  7: 401,
  6: 394,
  5: 387,
  4: 380,
  3: 372,
  2: 365,
  1: 358,
};

// **セットBのデータ**
export const dataB: DataObject = {
  1400: 7265,
  1399: 7261,
  1398: 7256,
  1397: 7251,
  1396: 7246,
  1395: 7242,
  1394: 7237,
  1393: 7232,
  1392: 7228,
  1391: 7223,
  1390: 7218,
  1389: 7213,
  1388: 7209,
  1387: 7204,
  1386: 7199,
  1385: 7194,
  1384: 7190,
  1383: 7185,
  1382: 7180,
  1381: 7176,
  1380: 7171,
  1379: 7166,
  1378: 7161,
  1377: 7157,
  1376: 7152,
  1375: 7147,
  1374: 7142,
  1373: 7138,
  1372: 7133,
  1371: 7128,
  1370: 7123,
  1369: 7119,
  1368: 7114,
  1367: 7109,
  1366: 7105,
  1365: 7100,
  1364: 7095,
  1363: 7090,
  1362: 7086,
  1361: 7081,
  1360: 7076,
  1359: 7071,
  1358: 7067,
  1357: 7062,
  1356: 7057,
  1355: 7052,
  1354: 7048,
  1353: 7043,
  1352: 7038,
  1351: 7033,
  1350: 7029,
  1349: 7024,
  1348: 7019,
  1347: 7015,
  1346: 7010,
  1345: 7005,
  1344: 7000,
  1343: 6996,
  1342: 6991,
  1341: 6986,
  1340: 6981,
  1339: 6977,
  1338: 6972,
  1337: 6967,
  1336: 6962,
  1335: 6958,
  1334: 6953,
  1333: 6948,
  1332: 6943,
  1331: 6939,
  1330: 6934,
  1329: 6929,
  1328: 6924,
  1327: 6920,
  1326: 6915,
  1325: 6910,
  1324: 6905,
  1323: 6901,
  1322: 6896,
  1321: 6891,
  1320: 6886,
  1319: 6882,
  1318: 6877,
  1317: 6872,
  1316: 6867,
  1315: 6863,
  1314: 6858,
  1313: 6853,
  1312: 6848,
  1311: 6844,
  1310: 6839,
  1309: 6834,
  1308: 6829,
  1307: 6825,
  1306: 6820,
  1305: 6815,
  1304: 6810,
  1303: 6806,
  1302: 6801,
  1301: 6796,
  1300: 6791,
  1299: 6786,
  1298: 6782,
  1297: 6777,
  1296: 6772,
  1295: 6767,
  1294: 6763,
  1293: 6758,
  1292: 6753,
  1291: 6748,
  1290: 6744,
  1289: 6739,
  1288: 6734,
  1287: 6729,
  1286: 6725,
  1285: 6720,
  1284: 6715,
  1283: 6710,
  1282: 6706,
  1281: 6701,
  1280: 6696,
  1279: 6691,
  1278: 6686,
  1277: 6682,
  1276: 6677,
  1275: 6672,
  1274: 6667,
  1273: 6663,
  1272: 6658,
  1271: 6653,
  1270: 6648,
  1269: 6644,
  1268: 6639,
  1267: 6634,
  1266: 6629,
  1265: 6624,
  1264: 6620,
  1263: 6615,
  1262: 6610,
  1261: 6605,
  1260: 6601,
  1259: 6596,
  1258: 6591,
  1257: 6586,
  1256: 6581,
  1255: 6577,
  1254: 6572,
  1253: 6567,
  1252: 6562,
  1251: 6558,
  1250: 6553,
  1249: 6548,
  1248: 6543,
  1247: 6538,
  1246: 6534,
  1245: 6529,
  1244: 6524,
  1243: 6519,
  1242: 6515,
  1241: 6510,
  1240: 6505,
  1239: 6500,
  1238: 6495,
  1237: 6491,
  1236: 6486,
  1235: 6481,
  1234: 6476,
  1233: 6472,
  1232: 6467,
  1231: 6462,
  1230: 6457,
  1229: 6452,
  1228: 6448,
  1227: 6443,
  1226: 6438,
  1225: 6433,
  1224: 6428,
  1223: 6424,
  1222: 6419,
  1221: 6414,
  1220: 6409,
  1219: 6405,
  1218: 6400,
  1217: 6395,
  1216: 6390,
  1215: 6385,
  1214: 6381,
  1213: 6376,
  1212: 6371,
  1211: 6366,
  1210: 6361,
  1209: 6357,
  1208: 6352,
  1207: 6347,
  1206: 6342,
  1205: 6337,
  1204: 6333,
  1203: 6328,
  1202: 6323,
  1201: 6318,
  1200: 6313,
  1199: 6309,
  1198: 6304,
  1197: 6299,
  1196: 6294,
  1195: 6289,
  1194: 6285,
  1193: 6280,
  1192: 6275,
  1191: 6270,
  1190: 6265,
  1189: 6261,
  1188: 6256,
  1187: 6251,
  1186: 6246,
  1185: 6241,
  1184: 6237,
  1183: 6232,
  1182: 6227,
  1181: 6222,
  1180: 6217,
  1179: 6213,
  1178: 6208,
  1177: 6203,
  1176: 6198,
  1175: 6193,
  1174: 6189,
  1173: 6184,
  1172: 6179,
  1171: 6174,
  1170: 6169,
  1169: 6165,
  1168: 6160,
  1167: 6155,
  1166: 6150,
  1165: 6145,
  1164: 6140,
  1163: 6136,
  1162: 6131,
  1161: 6126,
  1160: 6121,
  1159: 6116,
  1158: 6112,
  1157: 6107,
  1156: 6102,
  1155: 6097,
  1154: 6092,
  1153: 6088,
  1152: 6083,
  1151: 6078,
  1150: 6073,
  1149: 6068,
  1148: 6063,
  1147: 6059,
  1146: 6054,
  1145: 6049,
  1144: 6044,
  1143: 6039,
  1142: 6035,
  1141: 6030,
  1140: 6025,
  1139: 6020,
  1138: 6015,
  1137: 6010,
  1136: 6006,
  1135: 6001,
  1134: 5996,
  1133: 5991,
  1132: 5986,
  1131: 5981,
  1130: 5977,
  1129: 5972,
  1128: 5967,
  1127: 5962,
  1126: 5957,
  1125: 5953,
  1124: 5948,
  1123: 5943,
  1122: 5938,
  1121: 5933,
  1120: 5928,
  1119: 5924,
  1118: 5919,
  1117: 5914,
  1116: 5909,
  1115: 5904,
  1114: 5899,
  1113: 5895,
  1112: 5890,
  1111: 5885,
  1110: 5880,
  1109: 5875,
  1108: 5870,
  1107: 5866,
  1106: 5861,
  1105: 5856,
  1104: 5851,
  1103: 5846,
  1102: 5841,
  1101: 5837,
  1100: 5832,
  1099: 5827,
  1098: 5822,
  1097: 5817,
  1096: 5812,
  1095: 5808,
  1094: 5803,
  1093: 5798,
  1092: 5793,
  1091: 5788,
  1090: 5783,
  1089: 5779,
  1088: 5774,
  1087: 5769,
  1086: 5764,
  1085: 5759,
  1084: 5754,
  1083: 5749,
  1082: 5745,
  1081: 5740,
  1080: 5735,
  1079: 5730,
  1078: 5725,
  1077: 5720,
  1076: 5716,
  1075: 5711,
  1074: 5706,
  1073: 5701,
  1072: 5696,
  1071: 5691,
  1070: 5686,
  1069: 5682,
  1068: 5677,
  1067: 5672,
  1066: 5667,
  1065: 5662,
  1064: 5657,
  1063: 5653,
  1062: 5648,
  1061: 5643,
  1060: 5638,
  1059: 5633,
  1058: 5628,
  1057: 5623,
  1056: 5619,
  1055: 5614,
  1054: 5609,
  1053: 5604,
  1052: 5599,
  1051: 5594,
  1050: 5589,
  1049: 5585,
  1048: 5580,
  1047: 5575,
  1046: 5570,
  1045: 5565,
  1044: 5560,
  1043: 5555,
  1042: 5551,
  1041: 5546,
  1040: 5541,
  1039: 5536,
  1038: 5531,
  1037: 5526,
  1036: 5521,
  1035: 5517,
  1034: 5512,
  1033: 5507,
  1032: 5502,
  1031: 5497,
  1030: 5492,
  1029: 5487,
  1028: 5482,
  1027: 5478,
  1026: 5473,
  1025: 5468,
  1024: 5463,
  1023: 5458,
  1022: 5453,
  1021: 5448,
  1020: 5444,
  1019: 5439,
  1018: 5434,
  1017: 5429,
  1016: 5424,
  1015: 5419,
  1014: 5414,
  1013: 5409,
  1012: 5405,
  1011: 5400,
  1010: 5395,
  1009: 5390,
  1008: 5385,
  1007: 5380,
  1006: 5375,
  1005: 5370,
  1004: 5366,
  1003: 5361,
  1002: 5356,
  1001: 5351,
  1000: 5346,
  999: 5341,
  998: 5336,
  997: 5331,
  996: 5327,
  995: 5322,
  994: 5317,
  993: 5312,
  992: 5307,
  991: 5302,
  990: 5297,
  989: 5292,
  988: 5288,
  987: 5283,
  986: 5278,
  985: 5273,
  984: 5268,
  983: 5263,
  982: 5258,
  981: 5253,
  980: 5248,
  979: 5244,
  978: 5239,
  977: 5234,
  976: 5229,
  975: 5224,
  974: 5219,
  973: 5214,
  972: 5209,
  971: 5204,
  970: 5200,
  969: 5195,
  968: 5190,
  967: 5185,
  966: 5180,
  965: 5175,
  964: 5170,
  963: 5165,
  962: 5160,
  961: 5156,
  960: 5151,
  959: 5146,
  958: 5141,
  957: 5136,
  956: 5131,
  955: 5126,
  954: 5121,
  953: 5116,
  952: 5112,
  951: 5107,
  950: 5102,
  949: 5097,
  948: 5092,
  947: 5087,
  946: 5082,
  945: 5077,
  944: 5072,
  943: 5067,
  942: 5063,
  941: 5058,
  940: 5053,
  939: 5048,
  938: 5043,
  937: 5038,
  936: 5033,
  935: 5028,
  934: 5023,
  933: 5018,
  932: 5014,
  931: 5009,
  930: 5004,
  929: 4999,
  928: 4994,
  927: 4989,
  926: 4984,
  925: 4979,
  924: 4974,
  923: 4969,
  922: 4964,
  921: 4960,
  920: 4955,
  919: 4950,
  918: 4945,
  917: 4940,
  916: 4935,
  915: 4930,
  914: 4925,
  913: 4920,
  912: 4915,
  911: 4910,
  910: 4906,
  909: 4901,
  908: 4896,
  907: 4891,
  906: 4886,
  905: 4881,
  904: 4876,
  903: 4871,
  902: 4866,
  901: 4861,
  900: 4856,
  899: 4851,
  898: 4847,
  897: 4842,
  896: 4837,
  895: 4832,
  894: 4827,
  893: 4822,
  892: 4817,
  891: 4812,
  890: 4807,
  889: 4802,
  888: 4797,
  887: 4792,
  886: 4787,
  885: 4783,
  884: 4778,
  883: 4773,
  882: 4768,
  881: 4763,
  880: 4758,
  879: 4753,
  878: 4748,
  877: 4743,
  876: 4738,
  875: 4733,
  874: 4728,
  873: 4723,
  872: 4718,
  871: 4714,
  870: 4709,
  869: 4704,
  868: 4699,
  867: 4694,
  866: 4689,
  865: 4684,
  864: 4679,
  863: 4674,
  862: 4669,
  861: 4664,
  860: 4659,
  859: 4654,
  858: 4649,
  857: 4644,
  856: 4640,
  855: 4635,
  854: 4630,
  853: 4625,
  852: 4620,
  851: 4615,
  850: 4610,
  849: 4605,
  848: 4600,
  847: 4595,
  846: 4590,
  845: 4585,
  844: 4580,
  843: 4575,
  842: 4570,
  841: 4565,
  840: 4561,
  839: 4556,
  838: 4551,
  837: 4546,
  836: 4541,
  835: 4536,
  834: 4531,
  833: 4526,
  832: 4521,
  831: 4516,
  830: 4511,
  829: 4506,
  828: 4501,
  827: 4496,
  826: 4491,
  825: 4486,
  824: 4481,
  823: 4476,
  822: 4471,
  821: 4467,
  820: 4462,
  819: 4457,
  818: 4452,
  817: 4447,
  816: 4442,
  815: 4437,
  814: 4432,
  813: 4427,
  812: 4422,
  811: 4417,
  810: 4412,
  809: 4407,
  808: 4402,
  807: 4397,
  806: 4392,
  805: 4387,
  804: 4382,
  803: 4377,
  802: 4372,
  801: 4367,
  800: 4362,
  799: 4358,
  798: 4353,
  797: 4348,
  796: 4343,
  795: 4338,
  794: 4333,
  793: 4328,
  792: 4323,
  791: 4318,
  790: 4313,
  789: 4308,
  788: 4303,
  787: 4298,
  786: 4293,
  785: 4288,
  784: 4283,
  783: 4278,
  782: 4273,
  781: 4268,
  780: 4263,
  779: 4258,
  778: 4253,
  777: 4248,
  776: 4243,
  775: 4238,
  774: 4233,
  773: 4228,
  772: 4223,
  771: 4218,
  770: 4213,
  769: 4208,
  768: 4204,
  767: 4199,
  766: 4194,
  765: 4189,
  764: 4184,
  763: 4179,
  762: 4174,
  761: 4169,
  760: 4164,
  759: 4159,
  758: 4154,
  757: 4149,
  756: 4144,
  755: 4139,
  754: 4134,
  753: 4129,
  752: 4124,
  751: 4119,
  750: 4114,
  749: 4109,
  748: 4104,
  747: 4099,
  746: 4094,
  745: 4089,
  744: 4084,
  743: 4079,
  742: 4074,
  741: 4069,
  740: 4064,
  739: 4059,
  738: 4054,
  737: 4049,
  736: 4044,
  735: 4039,
  734: 4034,
  733: 4029,
  732: 4024,
  731: 4019,
  730: 4014,
  729: 4009,
  728: 4004,
  727: 3999,
  726: 3994,
  725: 3989,
  724: 3984,
  723: 3979,
  722: 3974,
  721: 3969,
  720: 3964,
  719: 3959,
  718: 3954,
  717: 3949,
  716: 3944,
  715: 3939,
  714: 3934,
  713: 3929,
  712: 3924,
  711: 3919,
  710: 3914,
  709: 3909,
  708: 3904,
  707: 3899,
  706: 3894,
  705: 3889,
  704: 3884,
  703: 3879,
  702: 3874,
  701: 3869,
  700: 3864,
  699: 3859,
  698: 3854,
  697: 3849,
  696: 3844,
  695: 3839,
  694: 3834,
  693: 3829,
  692: 3824,
  691: 3819,
  690: 3814,
  689: 3809,
  688: 3804,
  687: 3799,
  686: 3794,
  685: 3789,
  684: 3784,
  683: 3779,
  682: 3774,
  681: 3769,
  680: 3764,
  679: 3759,
  678: 3754,
  677: 3749,
  676: 3744,
  675: 3739,
  674: 3734,
  673: 3729,
  672: 3724,
  671: 3719,
  670: 3714,
  669: 3709,
  668: 3704,
  667: 3699,
  666: 3694,
  665: 3689,
  664: 3684,
  663: 3679,
  662: 3674,
  661: 3669,
  660: 3664,
  659: 3659,
  658: 3654,
  657: 3649,
  656: 3644,
  655: 3639,
  654: 3634,
  653: 3629,
  652: 3624,
  651: 3619,
  650: 3614,
  649: 3609,
  648: 3604,
  647: 3598,
  646: 3593,
  645: 3588,
  644: 3583,
  643: 3578,
  642: 3573,
  641: 3568,
  640: 3563,
  639: 3558,
  638: 3553,
  637: 3548,
  636: 3543,
  635: 3538,
  634: 3533,
  633: 3528,
  632: 3523,
  631: 3518,
  630: 3513,
  629: 3508,
  628: 3503,
  627: 3498,
  626: 3493,
  625: 3488,
  624: 3483,
  623: 3478,
  622: 3473,
  621: 3468,
  620: 3463,
  619: 3458,
  618: 3453,
  617: 3447,
  616: 3442,
  615: 3437,
  614: 3432,
  613: 3427,
  612: 3422,
  611: 3417,
  610: 3412,
  609: 3407,
  608: 3402,
  607: 3397,
  606: 3392,
  605: 3387,
  604: 3382,
  603: 3377,
  602: 3372,
  601: 3367,
  600: 3362,
  599: 3357,
  598: 3352,
  597: 3347,
  596: 3342,
  595: 3337,
  594: 3331,
  593: 3326,
  592: 3321,
  591: 3316,
  590: 3311,
  589: 3306,
  588: 3301,
  587: 3296,
  586: 3291,
  585: 3286,
  584: 3281,
  583: 3276,
  582: 3271,
  581: 3266,
  580: 3261,
  579: 3256,
  578: 3251,
  577: 3246,
  576: 3240,
  575: 3235,
  574: 3230,
  573: 3225,
  572: 3220,
  571: 3215,
  570: 3210,
  569: 3205,
  568: 3200,
  567: 3195,
  566: 3190,
  565: 3185,
  564: 3180,
  563: 3175,
  562: 3170,
  561: 3165,
  560: 3159,
  559: 3154,
  558: 3149,
  557: 3144,
  556: 3139,
  555: 3134,
  554: 3129,
  553: 3124,
  552: 3119,
  551: 3114,
  550: 3109,
  549: 3104,
  548: 3099,
  547: 3094,
  546: 3088,
  545: 3083,
  544: 3078,
  543: 3073,
  542: 3068,
  541: 3063,
  540: 3058,
  539: 3053,
  538: 3048,
  537: 3043,
  536: 3038,
  535: 3033,
  534: 3028,
  533: 3023,
  532: 3017,
  531: 3012,
  530: 3007,
  529: 3002,
  528: 2997,
  527: 2992,
  526: 2987,
  525: 2982,
  524: 2977,
  523: 2972,
  522: 2967,
  521: 2962,
  520: 2956,
  519: 2951,
  518: 2946,
  517: 2941,
  516: 2936,
  515: 2931,
  514: 2926,
  513: 2921,
  512: 2916,
  511: 2911,
  510: 2906,
  509: 2901,
  508: 2895,
  507: 2890,
  506: 2885,
  505: 2880,
  504: 2875,
  503: 2870,
  502: 2865,
  501: 2860,
  500: 2855,
  499: 2850,
  498: 2844,
  497: 2839,
  496: 2834,
  495: 2829,
  494: 2824,
  493: 2819,
  492: 2814,
  491: 2809,
  490: 2804,
  489: 2799,
  488: 2794,
  487: 2788,
  486: 2783,
  485: 2778,
  484: 2773,
  483: 2768,
  482: 2763,
  481: 2758,
  480: 2753,
  479: 2748,
  478: 2743,
  477: 2737,
  476: 2732,
  475: 2727,
  474: 2722,
  473: 2717,
  472: 2712,
  471: 2707,
  470: 2702,
  469: 2697,
  468: 2691,
  467: 2686,
  466: 2681,
  465: 2676,
  464: 2671,
  463: 2666,
  462: 2661,
  461: 2656,
  460: 2651,
  459: 2645,
  458: 2640,
  457: 2635,
  456: 2630,
  455: 2625,
  454: 2620,
  453: 2615,
  452: 2610,
  451: 2605,
  450: 2599,
  449: 2594,
  448: 2589,
  447: 2584,
  446: 2579,
  445: 2574,
  444: 2569,
  443: 2564,
  442: 2558,
  441: 2553,
  440: 2548,
  439: 2543,
  438: 2538,
  437: 2533,
  436: 2528,
  435: 2523,
  434: 2517,
  433: 2512,
  432: 2507,
  431: 2502,
  430: 2497,
  429: 2492,
  428: 2487,
  427: 2482,
  426: 2476,
  425: 2471,
  424: 2466,
  423: 2461,
  422: 2456,
  421: 2451,
  420: 2446,
  419: 2441,
  418: 2435,
  417: 2430,
  416: 2425,
  415: 2420,
  414: 2415,
  413: 2410,
  412: 2405,
  411: 2400,
  410: 2394,
  409: 2389,
  408: 2384,
  407: 2379,
  406: 2374,
  405: 2369,
  404: 2364,
  403: 2358,
  402: 2353,
  401: 2348,
  400: 2343,
  399: 2338,
  398: 2333,
  397: 2328,
  396: 2322,
  395: 2317,
  394: 2312,
  393: 2307,
  392: 2302,
  391: 2297,
  390: 2292,
  389: 2286,
  388: 2281,
  387: 2276,
  386: 2271,
  385: 2266,
  384: 2261,
  383: 2256,
  382: 2250,
  381: 2245,
  380: 2240,
  379: 2235,
  378: 2230,
  377: 2225,
  376: 2219,
  375: 2214,
  374: 2209,
  373: 2204,
  372: 2199,
  371: 2194,
  370: 2189,
  369: 2183,
  368: 2178,
  367: 2173,
  366: 2168,
  365: 2163,
  364: 2158,
  363: 2152,
  362: 2147,
  361: 2142,
  360: 2137,
  359: 2132,
  358: 2127,
  357: 2122,
  356: 2116,
  355: 2111,
  354: 2106,
  353: 2101,
  352: 2096,
  351: 2091,
  350: 2085,
  349: 2080,
  348: 2075,
  347: 2070,
  346: 2065,
  345: 2060,
  344: 2054,
  343: 2049,
  342: 2044,
  341: 2039,
  340: 2034,
  339: 2029,
  338: 2023,
  337: 2018,
  336: 2013,
  335: 2008,
  334: 2003,
  333: 1998,
  332: 1992,
  331: 1987,
  330: 1982,
  329: 1977,
  328: 1972,
  327: 1966,
  326: 1961,
  325: 1956,
  324: 1951,
  323: 1946,
  322: 1941,
  321: 1935,
  320: 1930,
  319: 1925,
  318: 1920,
  317: 1915,
  316: 1909,
  315: 1904,
  314: 1899,
  313: 1894,
  312: 1889,
  311: 1884,
  310: 1878,
  309: 1873,
  308: 1868,
  307: 1863,
  306: 1858,
  305: 1852,
  304: 1847,
  303: 1842,
  302: 1837,
  301: 1832,
  300: 1827,
  299: 1821,
  298: 1816,
  297: 1811,
  296: 1806,
  295: 1801,
  294: 1795,
  293: 1790,
  292: 1785,
  291: 1780,
  290: 1775,
  289: 1769,
  288: 1764,
  287: 1759,
  286: 1754,
  285: 1749,
  284: 1743,
  283: 1738,
  282: 1733,
  281: 1728,
  280: 1723,
  279: 1717,
  278: 1712,
  277: 1707,
  276: 1702,
  275: 1697,
  274: 1691,
  273: 1686,
  272: 1681,
  271: 1676,
  270: 1671,
  269: 1665,
  268: 1660,
  267: 1655,
  266: 1650,
  265: 1645,
  264: 1639,
  263: 1634,
  262: 1629,
  261: 1624,
  260: 1619,
  259: 1613,
  258: 1608,
  257: 1603,
  256: 1598,
  255: 1593,
  254: 1587,
  253: 1582,
  252: 1577,
  251: 1572,
  250: 1566,
  249: 1561,
  248: 1556,
  247: 1551,
  246: 1546,
  245: 1540,
  244: 1535,
  243: 1530,
  242: 1525,
  241: 1520,
  240: 1514,
  239: 1509,
  238: 1504,
  237: 1499,
  236: 1493,
  235: 1488,
  234: 1483,
  233: 1478,
  232: 1473,
  231: 1467,
  230: 1462,
  229: 1457,
  228: 1452,
  227: 1446,
  226: 1441,
  225: 1436,
  224: 1431,
  223: 1426,
  222: 1420,
  221: 1415,
  220: 1410,
  219: 1405,
  218: 1399,
  217: 1394,
  216: 1389,
  215: 1384,
  214: 1378,
  213: 1373,
  212: 1368,
  211: 1363,
  210: 1358,
  209: 1352,
  208: 1347,
  207: 1342,
  206: 1337,
  205: 1331,
  204: 1326,
  203: 1321,
  202: 1316,
  201: 1310,
  200: 1305,
  199: 1300,
  198: 1295,
  197: 1289,
  196: 1284,
  195: 1279,
  194: 1274,
  193: 1269,
  192: 1263,
  191: 1258,
  190: 1253,
  189: 1248,
  188: 1242,
  187: 1237,
  186: 1232,
  185: 1227,
  184: 1221,
  183: 1216,
  182: 1211,
  181: 1206,
  180: 1200,
  179: 1195,
  178: 1190,
  177: 1185,
  176: 1179,
  175: 1174,
  174: 1169,
  173: 1164,
  172: 1158,
  171: 1153,
  170: 1148,
  169: 1143,
  168: 1137,
  167: 1132,
  166: 1127,
  165: 1122,
  164: 1116,
  163: 1111,
  162: 1106,
  161: 1101,
  160: 1095,
  159: 1090,
  158: 1085,
  157: 1079,
  156: 1074,
  155: 1069,
  154: 1064,
  153: 1058,
  152: 1053,
  151: 1048,
  150: 1043,
  149: 1037,
  148: 1032,
  147: 1027,
  146: 1022,
  145: 1016,
  144: 1011,
  143: 1006,
  142: 1001,
  141: 995,
  140: 990,
  139: 985,
  138: 979,
  137: 974,
  136: 969,
  135: 964,
  134: 958,
  133: 953,
  132: 948,
  131: 943,
  130: 937,
  129: 932,
  128: 927,
  127: 921,
  126: 916,
  125: 911,
  124: 906,
  123: 900,
  122: 895,
  121: 890,
  120: 884,
  119: 879,
  118: 874,
  117: 869,
  116: 863,
  115: 858,
  114: 853,
  113: 848,
  112: 842,
  111: 837,
  110: 832,
  109: 826,
  108: 821,
  107: 816,
  106: 811,
  105: 805,
  104: 800,
  103: 795,
  102: 789,
  101: 784,
  100: 779,
  99: 774,
  98: 768,
  97: 763,
  96: 758,
  95: 752,
  94: 747,
  93: 742,
  92: 736,
  91: 731,
  90: 726,
  89: 721,
  88: 715,
  87: 710,
  86: 705,
  85: 699,
  84: 694,
  83: 689,
  82: 684,
  81: 678,
  80: 673,
  79: 668,
  78: 662,
  77: 657,
  76: 652,
  75: 646,
  74: 641,
  73: 636,
  72: 630,
  71: 625,
  70: 620,
  69: 615,
  68: 609,
  67: 604,
  66: 599,
  65: 593,
  64: 588,
  63: 583,
  62: 577,
  61: 572,
  60: 567,
  59: 561,
  58: 556,
  57: 551,
  56: 546,
  55: 540,
  54: 535,
  53: 530,
  52: 524,
  51: 519,
  50: 514,
  49: 508,
  48: 503,
  47: 498,
  46: 492,
  45: 487,
  44: 482,
  43: 476,
  42: 471,
  41: 466,
  40: 460,
  39: 455,
  38: 450,
  37: 445,
  36: 439,
  35: 434,
  34: 429,
  33: 423,
  32: 418,
  31: 413,
  30: 407,
  29: 402,
  28: 397,
  27: 391,
  26: 386,
  25: 381,
  24: 375,
  23: 370,
  22: 365,
  21: 359,
  20: 354,
  19: 349,
  18: 343,
  17: 338,
  16: 333,
  15: 327,
  14: 322,
  13: 317,
  12: 311,
  11: 306,
  10: 301,
  9: 295,
  8: 290,
  7: 285,
  6: 279,
  5: 274,
  4: 269,
  3: 263,
  2: 258,
  1: 253,
};

export const dataC: DataObject = {
  1400: 7635,
  1399: 7630,
  1398: 7625,
  1397: 7620,
  1396: 7615,
  1395: 7610,
  1394: 7605,
  1393: 7600,
  1392: 7595,
  1391: 7590,
  1390: 7585,
  1389: 7580,
  1388: 7575,
  1387: 7570,
  1386: 7565,
  1385: 7560,
  1384: 7555,
  1383: 7550,
  1382: 7545,
  1381: 7540,
  1380: 7535,
  1379: 7530,
  1378: 7526,
  1377: 7521,
  1376: 7516,
  1375: 7511,
  1374: 7506,
  1373: 7501,
  1372: 7496,
  1371: 7491,
  1370: 7486,
  1369: 7481,
  1368: 7476,
  1367: 7471,
  1366: 7466,
  1365: 7461,
  1364: 7456,
  1363: 7451,
  1362: 7446,
  1361: 7441,
  1360: 7436,
  1359: 7431,
  1358: 7426,
  1357: 7421,
  1356: 7416,
  1355: 7411,
  1354: 7406,
  1353: 7401,
  1352: 7396,
  1351: 7391,
  1350: 7386,
  1349: 7381,
  1348: 7376,
  1347: 7371,
  1346: 7366,
  1345: 7361,
  1344: 7356,
  1343: 7351,
  1342: 7346,
  1341: 7341,
  1340: 7336,
  1339: 7331,
  1338: 7326,
  1337: 7321,
  1336: 7316,
  1335: 7311,
  1334: 7306,
  1333: 7301,
  1332: 7296,
  1331: 7291,
  1330: 7286,
  1329: 7281,
  1328: 7276,
  1327: 7271,
  1326: 7266,
  1325: 7261,
  1324: 7256,
  1323: 7251,
  1322: 7246,
  1321: 7241,
  1320: 7236,
  1319: 7231,
  1318: 7226,
  1317: 7221,
  1316: 7216,
  1315: 7211,
  1314: 7206,
  1313: 7201,
  1312: 7196,
  1311: 7191,
  1310: 7186,
  1309: 7181,
  1308: 7176,
  1307: 7171,
  1306: 7166,
  1305: 7161,
  1304: 7156,
  1303: 7151,
  1302: 7146,
  1301: 7141,
  1300: 7136,
  1299: 7131,
  1298: 7126,
  1297: 7121,
  1296: 7116,
  1295: 7111,
  1294: 7106,
  1293: 7101,
  1292: 7096,
  1291: 7091,
  1290: 7086,
  1289: 7081,
  1288: 7076,
  1287: 7071,
  1286: 7066,
  1285: 7061,
  1284: 7056,
  1283: 7051,
  1282: 7046,
  1281: 7041,
  1280: 7036,
  1279: 7031,
  1278: 7026,
  1277: 7021,
  1276: 7016,
  1275: 7011,
  1274: 7006,
  1273: 7001,
  1272: 6995,
  1271: 6990,
  1270: 6985,
  1269: 6980,
  1268: 6975,
  1267: 6970,
  1266: 6965,
  1265: 6960,
  1264: 6955,
  1263: 6950,
  1262: 6945,
  1261: 6940,
  1260: 6935,
  1259: 6930,
  1258: 6925,
  1257: 6920,
  1256: 6915,
  1255: 6910,
  1254: 6905,
  1253: 6900,
  1252: 6895,
  1251: 6890,
  1250: 6885,
  1249: 6880,
  1248: 6875,
  1247: 6870,
  1246: 6865,
  1245: 6860,
  1244: 6855,
  1243: 6850,
  1242: 6845,
  1241: 6840,
  1240: 6835,
  1239: 6830,
  1238: 6825,
  1237: 6820,
  1236: 6814,
  1235: 6809,
  1234: 6804,
  1233: 6799,
  1232: 6794,
  1231: 6789,
  1230: 6784,
  1229: 6779,
  1228: 6774,
  1227: 6769,
  1226: 6764,
  1225: 6759,
  1224: 6754,
  1223: 6749,
  1222: 6744,
  1221: 6739,
  1220: 6734,
  1219: 6729,
  1218: 6724,
  1217: 6719,
  1216: 6714,
  1215: 6709,
  1214: 6704,
  1213: 6699,
  1212: 6694,
  1211: 6688,
  1210: 6683,
  1209: 6678,
  1208: 6673,
  1207: 6668,
  1206: 6663,
  1205: 6658,
  1204: 6653,
  1203: 6648,
  1202: 6643,
  1201: 6638,
  1200: 6633,
  1199: 6628,
  1198: 6623,
  1197: 6618,
  1196: 6613,
  1195: 6608,
  1194: 6603,
  1193: 6598,
  1192: 6593,
  1191: 6587,
  1190: 6582,
  1189: 6577,
  1188: 6572,
  1187: 6567,
  1186: 6562,
  1185: 6557,
  1184: 6552,
  1183: 6547,
  1182: 6542,
  1181: 6537,
  1180: 6532,
  1179: 6527,
  1178: 6522,
  1177: 6517,
  1176: 6512,
  1175: 6507,
  1174: 6501,
  1173: 6496,
  1172: 6491,
  1171: 6486,
  1170: 6481,
  1169: 6476,
  1168: 6471,
  1167: 6466,
  1166: 6461,
  1165: 6456,
  1164: 6451,
  1163: 6446,
  1162: 6441,
  1161: 6436,
  1160: 6431,
  1159: 6426,
  1158: 6420,
  1157: 6415,
  1156: 6410,
  1155: 6405,
  1154: 6400,
  1153: 6395,
  1152: 6390,
  1151: 6385,
  1150: 6380,
  1149: 6375,
  1148: 6370,
  1147: 6365,
  1146: 6360,
  1145: 6355,
  1144: 6349,
  1143: 6344,
  1142: 6339,
  1141: 6334,
  1140: 6329,
  1139: 6324,
  1138: 6319,
  1137: 6314,
  1136: 6309,
  1135: 6304,
  1134: 6299,
  1133: 6294,
  1132: 6289,
  1131: 6283,
  1130: 6278,
  1129: 6273,
  1128: 6268,
  1127: 6263,
  1126: 6258,
  1125: 6253,
  1124: 6248,
  1123: 6243,
  1122: 6238,
  1121: 6233,
  1120: 6228,
  1119: 6223,
  1118: 6217,
  1117: 6212,
  1116: 6207,
  1115: 6202,
  1114: 6197,
  1113: 6192,
  1112: 6187,
  1111: 6182,
  1110: 6177,
  1109: 6172,
  1108: 6167,
  1107: 6161,
  1106: 6156,
  1105: 6151,
  1104: 6146,
  1103: 6141,
  1102: 6136,
  1101: 6131,
  1100: 6126,
  1099: 6121,
  1098: 6116,
  1097: 6111,
  1096: 6105,
  1095: 6100,
  1094: 6095,
  1093: 6090,
  1092: 6085,
  1091: 6080,
  1090: 6075,
  1089: 6070,
  1088: 6065,
  1087: 6060,
  1086: 6055,
  1085: 6049,
  1084: 6044,
  1083: 6039,
  1082: 6034,
  1081: 6029,
  1080: 6024,
  1079: 6019,
  1078: 6014,
  1077: 6009,
  1076: 6004,
  1075: 5998,
  1074: 5993,
  1073: 5988,
  1072: 5983,
  1071: 5978,
  1070: 5973,
  1069: 5968,
  1068: 5963,
  1067: 5958,
  1066: 5953,
  1065: 5947,
  1064: 5942,
  1063: 5937,
  1062: 5932,
  1061: 5927,
  1060: 5922,
  1059: 5917,
  1058: 5912,
  1057: 5907,
  1056: 5901,
  1055: 5896,
  1054: 5891,
  1053: 5886,
  1052: 5881,
  1051: 5876,
  1050: 5871,
  1049: 5866,
  1048: 5861,
  1047: 5855,
  1046: 5850,
  1045: 5845,
  1044: 5840,
  1043: 5835,
  1042: 5830,
  1041: 5825,
  1040: 5820,
  1039: 5814,
  1038: 5809,
  1037: 5804,
  1036: 5799,
  1035: 5794,
  1034: 5789,
  1033: 5784,
  1032: 5779,
  1031: 5774,
  1030: 5768,
  1029: 5763,
  1028: 5758,
  1027: 5753,
  1026: 5748,
  1025: 5743,
  1024: 5738,
  1023: 5733,
  1022: 5727,
  1021: 5722,
  1020: 5717,
  1019: 5712,
  1018: 5707,
  1017: 5702,
  1016: 5697,
  1015: 5692,
  1014: 5686,
  1013: 5681,
  1012: 5676,
  1011: 5671,
  1010: 5666,
  1009: 5661,
  1008: 5656,
  1007: 5651,
  1006: 5645,
  1005: 5640,
  1004: 5635,
  1003: 5630,
  1002: 5625,
  1001: 5620,
  1000: 5615,
  999: 5609,
  998: 5604,
  997: 5599,
  996: 5594,
  995: 5589,
  994: 5584,
  993: 5579,
  992: 5574,
  991: 5568,
  990: 5563,
  989: 5558,
  988: 5553,
  987: 5548,
  986: 5543,
  985: 5538,
  984: 5532,
  983: 5527,
  982: 5522,
  981: 5517,
  980: 5512,
  979: 5507,
  978: 5502,
  977: 5496,
  976: 5491,
  975: 5486,
  974: 5481,
  973: 5476,
  972: 5471,
  971: 5466,
  970: 5460,
  969: 5455,
  968: 5450,
  967: 5445,
  966: 5440,
  965: 5435,
  964: 5430,
  963: 5424,
  962: 5419,
  961: 5414,
  960: 5409,
  959: 5404,
  958: 5399,
  957: 5393,
  956: 5388,
  955: 5383,
  954: 5378,
  953: 5373,
  952: 5368,
  951: 5363,
  950: 5357,
  949: 5352,
  948: 5347,
  947: 5342,
  946: 5337,
  945: 5332,
  944: 5326,
  943: 5321,
  942: 5316,
  941: 5311,
  940: 5306,
  939: 5301,
  938: 5295,
  937: 5290,
  936: 5285,
  935: 5280,
  934: 5275,
  933: 5270,
  932: 5265,
  931: 5259,
  930: 5254,
  929: 5249,
  928: 5244,
  927: 5239,
  926: 5234,
  925: 5228,
  924: 5223,
  923: 5218,
  922: 5213,
  921: 5208,
  920: 5203,
  919: 5197,
  918: 5192,
  917: 5187,
  916: 5182,
  915: 5177,
  914: 5172,
  913: 5166,
  912: 5161,
  911: 5156,
  910: 5151,
  909: 5146,
  908: 5140,
  907: 5135,
  906: 5130,
  905: 5125,
  904: 5120,
  903: 5115,
  902: 5109,
  901: 5104,
  900: 5099,
  899: 5094,
  898: 5089,
  897: 5084,
  896: 5078,
  895: 5073,
  894: 5068,
  893: 5063,
  892: 5058,
  891: 5052,
  890: 5047,
  889: 5042,
  888: 5037,
  887: 5032,
  886: 5027,
  885: 5021,
  884: 5016,
  883: 5011,
  882: 5006,
  881: 5001,
  880: 4995,
  879: 4990,
  878: 4985,
  877: 4980,
  876: 4975,
  875: 4970,
  874: 4964,
  873: 4959,
  872: 4954,
  871: 4949,
  870: 4944,
  869: 4938,
  868: 4933,
  867: 4928,
  866: 4923,
  865: 4918,
  864: 4912,
  863: 4907,
  862: 4902,
  861: 4897,
  860: 4892,
  859: 4886,
  858: 4881,
  857: 4876,
  856: 4871,
  855: 4866,
  854: 4860,
  853: 4855,
  852: 4850,
  851: 4845,
  850: 4840,
  849: 4834,
  848: 4829,
  847: 4824,
  846: 4819,
  845: 4814,
  844: 4808,
  843: 4803,
  842: 4798,
  841: 4793,
  840: 4788,
  839: 4782,
  838: 4777,
  837: 4772,
  836: 4767,
  835: 4762,
  834: 4756,
  833: 4751,
  832: 4746,
  831: 4741,
  830: 4736,
  829: 4730,
  828: 4725,
  827: 4720,
  826: 4715,
  825: 4710,
  824: 4704,
  823: 4699,
  822: 4694,
  821: 4689,
  820: 4684,
  819: 4678,
  818: 4673,
  817: 4668,
  816: 4663,
  815: 4657,
  814: 4652,
  813: 4647,
  812: 4642,
  811: 4637,
  810: 4631,
  809: 4626,
  808: 4621,
  807: 4616,
  806: 4610,
  805: 4605,
  804: 4600,
  803: 4595,
  802: 4590,
  801: 4584,
  800: 4579,
  799: 4574,
  798: 4569,
  797: 4564,
  796: 4558,
  795: 4553,
  794: 4548,
  793: 4543,
  792: 4537,
  791: 4532,
  790: 4527,
  789: 4522,
  788: 4516,
  787: 4511,
  786: 4506,
  785: 4501,
  784: 4496,
  783: 4490,
  782: 4485,
  781: 4480,
  780: 4475,
  779: 4469,
  778: 4464,
  777: 4459,
  776: 4454,
  775: 4448,
  774: 4443,
  773: 4438,
  772: 4433,
  771: 4428,
  770: 4422,
  769: 4417,
  768: 4412,
  767: 4407,
  766: 4401,
  765: 4396,
  764: 4391,
  763: 4386,
  762: 4380,
  761: 4375,
  760: 4370,
  759: 4365,
  758: 4359,
  757: 4354,
  756: 4349,
  755: 4344,
  754: 4339,
  753: 4333,
  752: 4328,
  751: 4323,
  750: 4318,
  749: 4312,
  748: 4307,
  747: 4302,
  746: 4297,
  745: 4291,
  744: 4286,
  743: 4281,
  742: 4276,
  741: 4270,
  740: 4265,
  739: 4260,
  738: 4255,
  737: 4249,
  736: 4244,
  735: 4239,
  734: 4234,
  733: 4228,
  732: 4223,
  731: 4218,
  730: 4213,
  729: 4207,
  728: 4202,
  727: 4197,
  726: 4192,
  725: 4186,
  724: 4181,
  723: 4176,
  722: 4171,
  721: 4165,
  720: 4160,
  719: 4155,
  718: 4149,
  717: 4144,
  716: 4139,
  715: 4134,
  714: 4128,
  713: 4123,
  712: 4118,
  711: 4113,
  710: 4107,
  709: 4102,
  708: 4097,
  707: 4092,
  706: 4086,
  705: 4081,
  704: 4076,
  703: 4071,
  702: 4065,
  701: 4060,
  700: 4055,
  699: 4049,
  698: 4044,
  697: 4039,
  696: 4034,
  695: 4028,
  694: 4023,
  693: 4018,
  692: 4013,
  691: 4007,
  690: 4002,
  689: 3997,
  688: 3992,
  687: 3986,
  686: 3981,
  685: 3976,
  684: 3970,
  683: 3965,
  682: 3960,
  681: 3955,
  680: 3949,
  679: 3944,
  678: 3939,
  677: 3933,
  676: 3928,
  675: 3923,
  674: 3918,
  673: 3912,
  672: 3907,
  671: 3902,
  670: 3897,
  669: 3891,
  668: 3886,
  667: 3881,
  666: 3875,
  665: 3870,
  664: 3865,
  663: 3860,
  662: 3854,
  661: 3849,
  660: 3844,
  659: 3838,
  658: 3833,
  657: 3828,
  656: 3823,
  655: 3817,
  654: 3812,
  653: 3807,
  652: 3801,
  651: 3796,
  650: 3791,
  649: 3786,
  648: 3780,
  647: 3775,
  646: 3770,
  645: 3764,
  644: 3759,
  643: 3754,
  642: 3748,
  641: 3743,
  640: 3738,
  639: 3733,
  638: 3727,
  637: 3722,
  636: 3717,
  635: 3711,
  634: 3706,
  633: 3701,
  632: 3696,
  631: 3690,
  630: 3685,
  629: 3680,
  628: 3674,
  627: 3669,
  626: 3664,
  625: 3658,
  624: 3653,
  623: 3648,
  622: 3643,
  621: 3637,
  620: 3632,
  619: 3627,
  618: 3621,
  617: 3616,
  616: 3611,
  615: 3605,
  614: 3600,
  613: 3595,
  612: 3589,
  611: 3584,
  610: 3579,
  609: 3574,
  608: 3568,
  607: 3563,
  606: 3558,
  605: 3552,
  604: 3547,
  603: 3542,
  602: 3536,
  601: 3531,
  600: 3526,
  599: 3520,
  598: 3515,
  597: 3510,
  596: 3504,
  595: 3499,
  594: 3494,
  593: 3489,
  592: 3483,
  591: 3478,
  590: 3473,
  589: 3467,
  588: 3462,
  587: 3457,
  586: 3451,
  585: 3446,
  584: 3441,
  583: 3435,
  582: 3430,
  581: 3425,
  580: 3419,
  579: 3414,
  578: 3409,
  577: 3403,
  576: 3398,
  575: 3393,
  574: 3387,
  573: 3382,
  572: 3377,
  571: 3371,
  570: 3366,
  569: 3361,
  568: 3355,
  567: 3350,
  566: 3345,
  565: 3339,
  564: 3334,
  563: 3329,
  562: 3323,
  561: 3318,
  560: 3313,
  559: 3307,
  558: 3302,
  557: 3297,
  556: 3291,
  555: 3286,
  554: 3281,
  553: 3275,
  552: 3270,
  551: 3265,
  550: 3259,
  549: 3254,
  548: 3249,
  547: 3243,
  546: 3238,
  545: 3233,
  544: 3227,
  543: 3222,
  542: 3217,
  541: 3211,
  540: 3206,
  539: 3201,
  538: 3195,
  537: 3190,
  536: 3185,
  535: 3179,
  534: 3174,
  533: 3169,
  532: 3163,
  531: 3158,
  530: 3153,
  529: 3147,
  528: 3142,
  527: 3137,
  526: 3131,
  525: 3126,
  524: 3120,
  523: 3115,
  522: 3110,
  521: 3104,
  520: 3099,
  519: 3094,
  518: 3088,
  517: 3083,
  516: 3078,
  515: 3072,
  514: 3067,
  513: 3062,
  512: 3056,
  511: 3051,
  510: 3046,
  509: 3040,
  508: 3035,
  507: 3029,
  506: 3024,
  505: 3019,
  504: 3013,
  503: 3008,
  502: 3003,
  501: 2997,
  500: 2992,
  499: 2987,
  498: 2981,
  497: 2976,
  496: 2970,
  495: 2965,
  494: 2960,
  493: 2954,
  492: 2949,
  491: 2944,
  490: 2938,
  489: 2933,
  488: 2928,
  487: 2922,
  486: 2917,
  485: 2911,
  484: 2906,
  483: 2901,
  482: 2895,
  481: 2890,
  480: 2885,
  479: 2879,
  478: 2874,
  477: 2868,
  476: 2863,
  475: 2858,
  474: 2852,
  473: 2847,
  472: 2842,
  471: 2836,
  470: 2831,
  469: 2825,
  468: 2820,
  467: 2815,
  466: 2809,
  465: 2804,
  464: 2799,
  463: 2793,
  462: 2788,
  461: 2782,
  460: 2777,
  459: 2772,
  458: 2766,
  457: 2761,
  456: 2756,
  455: 2750,
  454: 2745,
  453: 2739,
  452: 2734,
  451: 2729,
  450: 2723,
  449: 2718,
  448: 2712,
  447: 2707,
  446: 2702,
  445: 2696,
  444: 2691,
  443: 2686,
  442: 2680,
  441: 2675,
  440: 2669,
  439: 2664,
  438: 2659,
  437: 2653,
  436: 2648,
  435: 2642,
  434: 2637,
  433: 2632,
  432: 2626,
  431: 2621,
  430: 2615,
  429: 2610,
  428: 2605,
  427: 2599,
  426: 2594,
  425: 2588,
  424: 2583,
  423: 2578,
  422: 2572,
  421: 2567,
  420: 2561,
  419: 2556,
  418: 2551,
  417: 2545,
  416: 2540,
  415: 2534,
  414: 2529,
  413: 2524,
  412: 2518,
  411: 2513,
  410: 2507,
  409: 2502,
  408: 2497,
  407: 2491,
  406: 2486,
  405: 2480,
  404: 2475,
  403: 2470,
  402: 2464,
  401: 2459,
  400: 2453,
  399: 2448,
  398: 2442,
  397: 2437,
  396: 2432,
  395: 2426,
  394: 2421,
  393: 2415,
  392: 2410,
  391: 2405,
  390: 2399,
  389: 2394,
  388: 2388,
  387: 2383,
  386: 2377,
  385: 2372,
  384: 2367,
  383: 2361,
  382: 2356,
  381: 2350,
  380: 2345,
  379: 2340,
  378: 2334,
  377: 2329,
  376: 2323,
  375: 2318,
  374: 2312,
  373: 2307,
  372: 2302,
  371: 2296,
  370: 2291,
  369: 2285,
  368: 2280,
  367: 2274,
  366: 2269,
  365: 2264,
  364: 2258,
  363: 2253,
  362: 2247,
  361: 2242,
  360: 2236,
  359: 2231,
  358: 2226,
  357: 2220,
  356: 2215,
  355: 2209,
  354: 2204,
  353: 2198,
  352: 2193,
  351: 2188,
  350: 2182,
  349: 2177,
  348: 2171,
  347: 2166,
  346: 2160,
  345: 2155,
  344: 2149,
  343: 2144,
  342: 2139,
  341: 2133,
  340: 2128,
  339: 2122,
  338: 2117,
  337: 2111,
  336: 2106,
  335: 2100,
  334: 2095,
  333: 2090,
  332: 2084,
  331: 2079,
  330: 2073,
  329: 2068,
  328: 2062,
  327: 2057,
  326: 2051,
  325: 2046,
  324: 2041,
  323: 2035,
  322: 2030,
  321: 2024,
  320: 2019,
  319: 2013,
  318: 2008,
  317: 2002,
  316: 1997,
  315: 1991,
  314: 1986,
  313: 1981,
  312: 1975,
  311: 1970,
  310: 1964,
  309: 1959,
  308: 1953,
  307: 1948,
  306: 1942,
  305: 1937,
  304: 1931,
  303: 1926,
  302: 1921,
  301: 1915,
  300: 1910,
  299: 1904,
  298: 1899,
  297: 1893,
  296: 1888,
  295: 1882,
  294: 1877,
  293: 1871,
  292: 1866,
  291: 1860,
  290: 1855,
  289: 1850,
  288: 1844,
  287: 1839,
  286: 1833,
  285: 1828,
  284: 1822,
  283: 1817,
  282: 1811,
  281: 1806,
  280: 1800,
  279: 1795,
  278: 1789,
  277: 1784,
  276: 1778,
  275: 1773,
  274: 1767,
  273: 1762,
  272: 1756,
  271: 1751,
  270: 1746,
  269: 1740,
  268: 1735,
  267: 1729,
  266: 1724,
  265: 1718,
  264: 1713,
  263: 1707,
  262: 1702,
  261: 1696,
  260: 1691,
  259: 1685,
  258: 1680,
  257: 1674,
  256: 1669,
  255: 1663,
  254: 1658,
  253: 1652,
  252: 1647,
  251: 1641,
  250: 1636,
  249: 1630,
  248: 1625,
  247: 1619,
  246: 1614,
  245: 1608,
  244: 1603,
  243: 1597,
  242: 1592,
  241: 1586,
  240: 1581,
  239: 1575,
  238: 1570,
  237: 1564,
  236: 1559,
  235: 1553,
  234: 1548,
  233: 1542,
  232: 1537,
  231: 1531,
  230: 1526,
  229: 1521,
  228: 1515,
  227: 1510,
  226: 1504,
  225: 1499,
  224: 1493,
  223: 1487,
  222: 1482,
  221: 1476,
  220: 1471,
  219: 1465,
  218: 1460,
  217: 1454,
  216: 1449,
  215: 1443,
  214: 1438,
  213: 1432,
  212: 1427,
  211: 1421,
  210: 1416,
  209: 1410,
  208: 1405,
  207: 1399,
  206: 1394,
  205: 1388,
  204: 1383,
  203: 1377,
  202: 1372,
  201: 1366,
  200: 1361,
  199: 1355,
  198: 1350,
  197: 1344,
  196: 1339,
  195: 1333,
  194: 1328,
  193: 1322,
  192: 1317,
  191: 1311,
  190: 1306,
  189: 1300,
  188: 1295,
  187: 1289,
  186: 1284,
  185: 1278,
  184: 1273,
  183: 1267,
  182: 1261,
  181: 1256,
  180: 1250,
  179: 1245,
  178: 1239,
  177: 1234,
  176: 1228,
  175: 1223,
  174: 1217,
  173: 1212,
  172: 1206,
  171: 1201,
  170: 1195,
  169: 1190,
  168: 1184,
  167: 1179,
  166: 1173,
  165: 1167,
  164: 1162,
  163: 1156,
  162: 1151,
  161: 1145,
  160: 1140,
  159: 1134,
  158: 1129,
  157: 1123,
  156: 1118,
  155: 1112,
  154: 1107,
  153: 1101,
  152: 1095,
  151: 1090,
  150: 1084,
  149: 1079,
  148: 1073,
  147: 1068,
  146: 1062,
  145: 1057,
  144: 1051,
  143: 1046,
  142: 1040,
  141: 1035,
  140: 1029,
  139: 1023,
  138: 1018,
  137: 1012,
  136: 1007,
  135: 1001,
  134: 996,
  133: 990,
  132: 985,
  131: 979,
  130: 973,
  129: 968,
  128: 962,
  127: 957,
  126: 951,
  125: 946,
  124: 940,
  123: 935,
  122: 929,
  121: 923,
  120: 918,
  119: 912,
  118: 907,
  117: 901,
  116: 896,
  115: 890,
  114: 885,
  113: 879,
  112: 873,
  111: 868,
  110: 862,
  109: 857,
  108: 851,
  107: 846,
  106: 840,
  105: 835,
  104: 829,
  103: 823,
  102: 818,
  101: 812,
  100: 807,
  99: 801,
  98: 796,
  97: 790,
  96: 784,
  95: 779,
  94: 773,
  93: 768,
  92: 762,
  91: 757,
  90: 751,
  89: 745,
  88: 740,
  87: 734,
  86: 729,
  85: 723,
  84: 718,
  83: 712,
  82: 706,
  81: 701,
  80: 695,
  79: 690,
  78: 684,
  77: 678,
  76: 673,
  75: 667,
  74: 662,
  73: 656,
  72: 651,
  71: 645,
  70: 639,
  69: 634,
  68: 628,
  67: 623,
  66: 617,
  65: 611,
  64: 606,
  63: 600,
  62: 595,
  61: 589,
  60: 584,
  59: 578,
  58: 572,
  57: 567,
  56: 561,
  55: 556,
  54: 550,
  53: 544,
  52: 539,
  51: 533,
  50: 528,
  49: 522,
  48: 516,
  47: 511,
  46: 505,
  45: 500,
  44: 494,
  43: 488,
  42: 483,
  41: 477,
  40: 472,
  39: 466,
  38: 460,
  37: 455,
  36: 449,
  35: 444,
  34: 438,
  33: 432,
  32: 427,
  31: 421,
  30: 416,
  29: 410,
  28: 404,
  27: 399,
  26: 393,
  25: 388,
  24: 382,
  23: 376,
  22: 371,
  21: 365,
  20: 359,
  19: 354,
  18: 348,
  17: 343,
  16: 337,
  15: 331,
  14: 326,
  13: 320,
  12: 315,
  11: 309,
  10: 303,
  9: 298,
  8: 292,
  7: 286,
  6: 281,
  5: 275,
  4: 270,
  3: 264,
  2: 258,
  1: 253,
};

export const dataD: DataObject = {
  1400: 5589,
  1399: 5585,
  1398: 5581,
  1397: 5578,
  1396: 5574,
  1395: 5571,
  1394: 5567,
  1393: 5563,
  1392: 5560,
  1391: 5556,
  1390: 5552,
  1389: 5549,
  1388: 5545,
  1387: 5541,
  1386: 5538,
  1385: 5534,
  1384: 5530,
  1383: 5527,
  1382: 5523,
  1381: 5520,
  1380: 5516,
  1379: 5512,
  1378: 5509,
  1377: 5505,
  1376: 5501,
  1375: 5498,
  1374: 5494,
  1373: 5490,
  1372: 5487,
  1371: 5483,
  1370: 5479,
  1369: 5476,
  1368: 5472,
  1367: 5468,
  1366: 5465,
  1365: 5461,
  1364: 5457,
  1363: 5454,
  1362: 5450,
  1361: 5447,
  1360: 5443,
  1359: 5439,
  1358: 5436,
  1357: 5432,
  1356: 5428,
  1355: 5425,
  1354: 5421,
  1353: 5417,
  1352: 5414,
  1351: 5410,
  1350: 5406,
  1349: 5403,
  1348: 5399,
  1347: 5395,
  1346: 5392,
  1345: 5388,
  1344: 5384,
  1343: 5381,
  1342: 5377,
  1341: 5373,
  1340: 5370,
  1339: 5366,
  1338: 5362,
  1337: 5359,
  1336: 5355,
  1335: 5351,
  1334: 5348,
  1333: 5344,
  1332: 5340,
  1331: 5337,
  1330: 5333,
  1329: 5329,
  1328: 5326,
  1327: 5322,
  1326: 5318,
  1325: 5315,
  1324: 5311,
  1323: 5307,
  1322: 5304,
  1321: 5300,
  1320: 5296,
  1319: 5293,
  1318: 5289,
  1317: 5285,
  1316: 5282,
  1315: 5278,
  1314: 5274,
  1313: 5271,
  1312: 5267,
  1311: 5263,
  1310: 5260,
  1309: 5256,
  1308: 5252,
  1307: 5249,
  1306: 5245,
  1305: 5241,
  1304: 5238,
  1303: 5234,
  1302: 5230,
  1301: 5227,
  1300: 5223,
  1299: 5219,
  1298: 5216,
  1297: 5212,
  1296: 5208,
  1295: 5205,
  1294: 5201,
  1293: 5197,
  1292: 5194,
  1291: 5190,
  1290: 5186,
  1289: 5183,
  1288: 5179,
  1287: 5175,
  1286: 5172,
  1285: 5168,
  1284: 5164,
  1283: 5161,
  1282: 5157,
  1281: 5153,
  1280: 5150,
  1279: 5146,
  1278: 5142,
  1277: 5139,
  1276: 5135,
  1275: 5131,
  1274: 5128,
  1273: 5124,
  1272: 5120,
  1271: 5117,
  1270: 5113,
  1269: 5109,
  1268: 5105,
  1267: 5102,
  1266: 5098,
  1265: 5094,
  1264: 5091,
  1263: 5087,
  1262: 5083,
  1261: 5080,
  1260: 5076,
  1259: 5072,
  1258: 5069,
  1257: 5065,
  1256: 5061,
  1255: 5058,
  1254: 5054,
  1253: 5050,
  1252: 5047,
  1251: 5043,
  1250: 5039,
  1249: 5036,
  1248: 5032,
  1247: 5028,
  1246: 5024,
  1245: 5021,
  1244: 5017,
  1243: 5013,
  1242: 5010,
  1241: 5006,
  1240: 5002,
  1239: 4999,
  1238: 4995,
  1237: 4991,
  1236: 4988,
  1235: 4984,
  1234: 4980,
  1233: 4976,
  1232: 4973,
  1231: 4969,
  1230: 4965,
  1229: 4962,
  1228: 4958,
  1227: 4954,
  1226: 4951,
  1225: 4947,
  1224: 4943,
  1223: 4940,
  1222: 4936,
  1221: 4932,
  1220: 4928,
  1219: 4925,
  1218: 4921,
  1217: 4917,
  1216: 4914,
  1215: 4910,
  1214: 4906,
  1213: 4903,
  1212: 4899,
  1211: 4895,
  1210: 4892,
  1209: 4888,
  1208: 4884,
  1207: 4880,
  1206: 4877,
  1205: 4873,
  1204: 4869,
  1203: 4866,
  1202: 4862,
  1201: 4858,
  1200: 4855,
  1199: 4851,
  1198: 4847,
  1197: 4843,
  1196: 4840,
  1195: 4836,
  1194: 4832,
  1193: 4829,
  1192: 4825,
  1191: 4821,
  1190: 4818,
  1189: 4814,
  1188: 4810,
  1187: 4806,
  1186: 4803,
  1185: 4799,
  1184: 4795,
  1183: 4792,
  1182: 4788,
  1181: 4784,
  1180: 4780,
  1179: 4777,
  1178: 4773,
  1177: 4769,
  1176: 4766,
  1175: 4762,
  1174: 4758,
  1173: 4755,
  1172: 4751,
  1171: 4747,
  1170: 4743,
  1169: 4740,
  1168: 4736,
  1167: 4732,
  1166: 4729,
  1165: 4725,
  1164: 4721,
  1163: 4717,
  1162: 4714,
  1161: 4710,
  1160: 4706,
  1159: 4703,
  1158: 4699,
  1157: 4695,
  1156: 4691,
  1155: 4688,
  1154: 4684,
  1153: 4680,
  1152: 4677,
  1151: 4673,
  1150: 4669,
  1149: 4665,
  1148: 4662,
  1147: 4658,
  1146: 4654,
  1145: 4651,
  1144: 4647,
  1143: 4643,
  1142: 4639,
  1141: 4636,
  1140: 4632,
  1139: 4628,
  1138: 4625,
  1137: 4621,
  1136: 4617,
  1135: 4613,
  1134: 4610,
  1133: 4606,
  1132: 4602,
  1131: 4598,
  1130: 4595,
  1129: 4591,
  1128: 4587,
  1127: 4584,
  1126: 4580,
  1125: 4576,
  1124: 4572,
  1123: 4569,
  1122: 4565,
  1121: 4561,
  1120: 4558,
  1119: 4554,
  1118: 4550,
  1117: 4546,
  1116: 4543,
  1115: 4539,
  1114: 4535,
  1113: 4531,
  1112: 4528,
  1111: 4524,
  1110: 4520,
  1109: 4517,
  1108: 4513,
  1107: 4509,
  1106: 4505,
  1105: 4502,
  1104: 4498,
  1103: 4494,
  1102: 4490,
  1101: 4487,
  1100: 4483,
  1099: 4479,
  1098: 4476,
  1097: 4472,
  1096: 4468,
  1095: 4464,
  1094: 4461,
  1093: 4457,
  1092: 4453,
  1091: 4449,
  1090: 4446,
  1089: 4442,
  1088: 4438,
  1087: 4434,
  1086: 4431,
  1085: 4427,
  1084: 4423,
  1083: 4420,
  1082: 4416,
  1081: 4412,
  1080: 4408,
  1079: 4405,
  1078: 4401,
  1077: 4397,
  1076: 4393,
  1075: 4390,
  1074: 4386,
  1073: 4382,
  1072: 4378,
  1071: 4375,
  1070: 4371,
  1069: 4367,
  1068: 4363,
  1067: 4360,
  1066: 4356,
  1065: 4352,
  1064: 4348,
  1063: 4345,
  1062: 4341,
  1061: 4337,
  1060: 4334,
  1059: 4330,
  1058: 4326,
  1057: 4322,
  1056: 4319,
  1055: 4315,
  1054: 4311,
  1053: 4307,
  1052: 4304,
  1051: 4300,
  1050: 4296,
  1049: 4292,
  1048: 4289,
  1047: 4285,
  1046: 4281,
  1045: 4277,
  1044: 4274,
  1043: 4270,
  1042: 4266,
  1041: 4262,
  1040: 4259,
  1039: 4255,
  1038: 4251,
  1037: 4247,
  1036: 4244,
  1035: 4240,
  1034: 4236,
  1033: 4232,
  1032: 4229,
  1031: 4225,
  1030: 4221,
  1029: 4217,
  1028: 4214,
  1027: 4210,
  1026: 4206,
  1025: 4202,
  1024: 4199,
  1023: 4195,
  1022: 4191,
  1021: 4187,
  1020: 4184,
  1019: 4180,
  1018: 4176,
  1017: 4172,
  1016: 4169,
  1015: 4165,
  1014: 4161,
  1013: 4157,
  1012: 4153,
  1011: 4150,
  1010: 4146,
  1009: 4142,
  1008: 4138,
  1007: 4135,
  1006: 4131,
  1005: 4127,
  1004: 4123,
  1003: 4120,
  1002: 4116,
  1001: 4112,
  1000: 4108,
  999: 4105,
  998: 4101,
  997: 4097,
  996: 4093,
  995: 4090,
  994: 4086,
  993: 4082,
  992: 4078,
  991: 4074,
  990: 4071,
  989: 4067,
  988: 4063,
  987: 4059,
  986: 4056,
  985: 4052,
  984: 4048,
  983: 4044,
  982: 4041,
  981: 4037,
  980: 4033,
  979: 4029,
  978: 4026,
  977: 4022,
  976: 4018,
  975: 4014,
  974: 4010,
  973: 4007,
  972: 4003,
  971: 3999,
  970: 3995,
  969: 3992,
  968: 3988,
  967: 3984,
  966: 3980,
  965: 3977,
  964: 3973,
  963: 3969,
  962: 3965,
  961: 3961,
  960: 3958,
  959: 3954,
  958: 3950,
  957: 3946,
  956: 3943,
  955: 3939,
  954: 3935,
  953: 3931,
  952: 3927,
  951: 3924,
  950: 3920,
  949: 3916,
  948: 3912,
  947: 3909,
  946: 3905,
  945: 3901,
  944: 3897,
  943: 3893,
  942: 3890,
  941: 3886,
  940: 3882,
  939: 3878,
  938: 3875,
  937: 3871,
  936: 3867,
  935: 3863,
  934: 3859,
  933: 3856,
  932: 3852,
  931: 3848,
  930: 3844,
  929: 3840,
  928: 3837,
  927: 3833,
  926: 3829,
  925: 3825,
  924: 3822,
  923: 3818,
  922: 3814,
  921: 3810,
  920: 3806,
  919: 3803,
  918: 3799,
  917: 3795,
  916: 3791,
  915: 3787,
  914: 3784,
  913: 3780,
  912: 3776,
  911: 3772,
  910: 3769,
  909: 3765,
  908: 3761,
  907: 3757,
  906: 3753,
  905: 3750,
  904: 3746,
  903: 3742,
  902: 3738,
  901: 3734,
  900: 3731,
  899: 3727,
  898: 3723,
  897: 3719,
  896: 3715,
  895: 3712,
  894: 3708,
  893: 3704,
  892: 3700,
  891: 3696,
  890: 3693,
  889: 3689,
  888: 3685,
  887: 3681,
  886: 3677,
  885: 3674,
  884: 3670,
  883: 3666,
  882: 3662,
  881: 3658,
  880: 3655,
  879: 3651,
  878: 3647,
  877: 3643,
  876: 3639,
  875: 3636,
  874: 3632,
  873: 3628,
  872: 3624,
  871: 3620,
  870: 3617,
  869: 3613,
  868: 3609,
  867: 3605,
  866: 3601,
  865: 3598,
  864: 3594,
  863: 3590,
  862: 3586,
  861: 3582,
  860: 3579,
  859: 3575,
  858: 3571,
  857: 3567,
  856: 3563,
  855: 3560,
  854: 3556,
  853: 3552,
  852: 3548,
  851: 3544,
  850: 3541,
  849: 3537,
  848: 3533,
  847: 3529,
  846: 3525,
  845: 3521,
  844: 3518,
  843: 3514,
  842: 3510,
  841: 3506,
  840: 3502,
  839: 3499,
  838: 3495,
  837: 3491,
  836: 3487,
  835: 3483,
  834: 3480,
  833: 3476,
  832: 3472,
  831: 3468,
  830: 3464,
  829: 3460,
  828: 3457,
  827: 3453,
  826: 3449,
  825: 3445,
  824: 3441,
  823: 3438,
  822: 3434,
  821: 3430,
  820: 3426,
  819: 3422,
  818: 3418,
  817: 3415,
  816: 3411,
  815: 3407,
  814: 3403,
  813: 3399,
  812: 3396,
  811: 3392,
  810: 3388,
  809: 3384,
  808: 3380,
  807: 3376,
  806: 3373,
  805: 3369,
  804: 3365,
  803: 3361,
  802: 3357,
  801: 3353,
  800: 3350,
  799: 3346,
  798: 3342,
  797: 3338,
  796: 3334,
  795: 3331,
  794: 3327,
  793: 3323,
  792: 3319,
  791: 3315,
  790: 3311,
  789: 3308,
  788: 3304,
  787: 3300,
  786: 3296,
  785: 3292,
  784: 3288,
  783: 3285,
  782: 3281,
  781: 3277,
  780: 3273,
  779: 3269,
  778: 3265,
  777: 3262,
  776: 3258,
  775: 3254,
  774: 3250,
  773: 3246,
  772: 3242,
  771: 3239,
  770: 3235,
  769: 3231,
  768: 3227,
  767: 3223,
  766: 3219,
  765: 3216,
  764: 3212,
  763: 3208,
  762: 3204,
  761: 3200,
  760: 3196,
  759: 3192,
  758: 3189,
  757: 3185,
  756: 3181,
  755: 3177,
  754: 3173,
  753: 3169,
  752: 3166,
  751: 3162,
  750: 3158,
  749: 3154,
  748: 3150,
  747: 3146,
  746: 3143,
  745: 3139,
  744: 3135,
  743: 3131,
  742: 3127,
  741: 3123,
  740: 3119,
  739: 3116,
  738: 3112,
  737: 3108,
  736: 3104,
  735: 3100,
  734: 3096,
  733: 3093,
  732: 3089,
  731: 3085,
  730: 3081,
  729: 3077,
  728: 3073,
  727: 3069,
  726: 3066,
  725: 3062,
  724: 3058,
  723: 3054,
  722: 3050,
  721: 3046,
  720: 3042,
  719: 3039,
  718: 3035,
  717: 3031,
  716: 3027,
  715: 3023,
  714: 3019,
  713: 3016,
  712: 3012,
  711: 3008,
  710: 3004,
  709: 3000,
  708: 2996,
  707: 2992,
  706: 2989,
  705: 2985,
  704: 2981,
  703: 2977,
  702: 2973,
  701: 2969,
  700: 2965,
  699: 2962,
  698: 2958,
  697: 2954,
  696: 2950,
  695: 2946,
  694: 2942,
  693: 2938,
  692: 2934,
  691: 2931,
  690: 2927,
  689: 2923,
  688: 2919,
  687: 2915,
  686: 2911,
  685: 2907,
  684: 2904,
  683: 2900,
  682: 2896,
  681: 2892,
  680: 2888,
  679: 2884,
  678: 2880,
  677: 2877,
  676: 2873,
  675: 2869,
  674: 2865,
  673: 2861,
  672: 2857,
  671: 2853,
  670: 2849,
  669: 2846,
  668: 2842,
  667: 2838,
  666: 2834,
  665: 2830,
  664: 2826,
  663: 2822,
  662: 2818,
  661: 2815,
  660: 2811,
  659: 2807,
  658: 2803,
  657: 2799,
  656: 2795,
  655: 2791,
  654: 2787,
  653: 2784,
  652: 2780,
  651: 2776,
  650: 2772,
  649: 2768,
  648: 2764,
  647: 2760,
  646: 2756,
  645: 2753,
  644: 2749,
  643: 2745,
  642: 2741,
  641: 2737,
  640: 2733,
  639: 2729,
  638: 2725,
  637: 2722,
  636: 2718,
  635: 2714,
  634: 2710,
  633: 2706,
  632: 2702,
  631: 2698,
  630: 2694,
  629: 2690,
  628: 2687,
  627: 2683,
  626: 2679,
  625: 2675,
  624: 2671,
  623: 2667,
  622: 2663,
  621: 2659,
  620: 2656,
  619: 2652,
  618: 2648,
  617: 2644,
  616: 2640,
  615: 2636,
  614: 2632,
  613: 2628,
  612: 2624,
  611: 2621,
  610: 2617,
  609: 2613,
  608: 2609,
  607: 2605,
  606: 2601,
  605: 2597,
  604: 2593,
  603: 2589,
  602: 2586,
  601: 2582,
  600: 2578,
  599: 2574,
  598: 2570,
  597: 2566,
  596: 2562,
  595: 2558,
  594: 2554,
  593: 2550,
  592: 2547,
  591: 2543,
  590: 2539,
  589: 2535,
  588: 2531,
  587: 2527,
  586: 2523,
  585: 2519,
  584: 2515,
  583: 2511,
  582: 2508,
  581: 2504,
  580: 2500,
  579: 2496,
  578: 2492,
  577: 2488,
  576: 2484,
  575: 2480,
  574: 2476,
  573: 2472,
  572: 2469,
  571: 2465,
  570: 2461,
  569: 2457,
  568: 2453,
  567: 2449,
  566: 2445,
  565: 2441,
  564: 2437,
  563: 2433,
  562: 2430,
  561: 2426,
  560: 2422,
  559: 2418,
  558: 2414,
  557: 2410,
  556: 2406,
  555: 2402,
  554: 2398,
  553: 2394,
  552: 2390,
  551: 2387,
  550: 2383,
  549: 2379,
  548: 2375,
  547: 2371,
  546: 2367,
  545: 2363,
  544: 2359,
  543: 2355,
  542: 2351,
  541: 2347,
  540: 2343,
  539: 2340,
  538: 2336,
  537: 2332,
  536: 2328,
  535: 2324,
  534: 2320,
  533: 2316,
  532: 2312,
  531: 2308,
  530: 2304,
  529: 2300,
  528: 2296,
  527: 2293,
  526: 2289,
  525: 2285,
  524: 2281,
  523: 2277,
  522: 2273,
  521: 2269,
  520: 2265,
  519: 2261,
  518: 2257,
  517: 2253,
  516: 2249,
  515: 2245,
  514: 2242,
  513: 2238,
  512: 2234,
  511: 2230,
  510: 2226,
  509: 2222,
  508: 2218,
  507: 2214,
  506: 2210,
  505: 2206,
  504: 2202,
  503: 2198,
  502: 2194,
  501: 2191,
  500: 2187,
  499: 2183,
  498: 2179,
  497: 2175,
  496: 2171,
  495: 2167,
  494: 2163,
  493: 2159,
  492: 2155,
  491: 2151,
  490: 2147,
  489: 2143,
  488: 2139,
  487: 2135,
  486: 2132,
  485: 2128,
  484: 2124,
  483: 2120,
  482: 2116,
  481: 2112,
  480: 2108,
  479: 2104,
  478: 2100,
  477: 2096,
  476: 2092,
  475: 2088,
  474: 2084,
  473: 2080,
  472: 2076,
  471: 2072,
  470: 2069,
  469: 2065,
  468: 2061,
  467: 2057,
  466: 2053,
  465: 2049,
  464: 2045,
  463: 2041,
  462: 2037,
  461: 2033,
  460: 2029,
  459: 2025,
  458: 2021,
  457: 2017,
  456: 2013,
  455: 2009,
  454: 2005,
  453: 2002,
  452: 1998,
  451: 1994,
  450: 1990,
  449: 1986,
  448: 1982,
  447: 1978,
  446: 1974,
  445: 1970,
  444: 1966,
  443: 1962,
  442: 1958,
  441: 1954,
  440: 1950,
  439: 1946,
  438: 1942,
  437: 1938,
  436: 1934,
  435: 1930,
  434: 1926,
  433: 1923,
  432: 1919,
  431: 1915,
  430: 1911,
  429: 1907,
  428: 1903,
  427: 1899,
  426: 1895,
  425: 1891,
  424: 1887,
  423: 1883,
  422: 1879,
  421: 1875,
  420: 1871,
  419: 1867,
  418: 1863,
  417: 1859,
  416: 1855,
  415: 1851,
  414: 1847,
  413: 1843,
  412: 1839,
  411: 1835,
  410: 1832,
  409: 1828,
  408: 1824,
  407: 1820,
  406: 1816,
  405: 1812,
  404: 1808,
  403: 1804,
  402: 1800,
  401: 1796,
  400: 1792,
  399: 1788,
  398: 1784,
  397: 1780,
  396: 1776,
  395: 1772,
  394: 1768,
  393: 1764,
  392: 1760,
  391: 1756,
  390: 1752,
  389: 1748,
  388: 1744,
  387: 1740,
  386: 1736,
  385: 1732,
  384: 1728,
  383: 1724,
  382: 1720,
  381: 1716,
  380: 1713,
  379: 1709,
  378: 1705,
  377: 1701,
  376: 1697,
  375: 1693,
  374: 1689,
  373: 1685,
  372: 1681,
  371: 1677,
  370: 1673,
  369: 1669,
  368: 1665,
  367: 1661,
  366: 1657,
  365: 1653,
  364: 1649,
  363: 1645,
  362: 1641,
  361: 1637,
  360: 1633,
  359: 1629,
  358: 1625,
  357: 1621,
  356: 1617,
  355: 1613,
  354: 1609,
  353: 1605,
  352: 1601,
  351: 1597,
  350: 1593,
  349: 1589,
  348: 1585,
  347: 1581,
  346: 1577,
  345: 1573,
  344: 1569,
  343: 1565,
  342: 1561,
  341: 1557,
  340: 1553,
  339: 1549,
  338: 1545,
  337: 1541,
  336: 1537,
  335: 1533,
  334: 1529,
  333: 1525,
  332: 1521,
  331: 1517,
  330: 1513,
  329: 1509,
  328: 1505,
  327: 1501,
  326: 1497,
  325: 1493,
  324: 1489,
  323: 1485,
  322: 1481,
  321: 1477,
  320: 1473,
  319: 1469,
  318: 1465,
  317: 1461,
  316: 1457,
  315: 1454,
  314: 1450,
  313: 1446,
  312: 1442,
  311: 1438,
  310: 1434,
  309: 1430,
  308: 1426,
  307: 1422,
  306: 1418,
  305: 1414,
  304: 1410,
  303: 1406,
  302: 1402,
  301: 1398,
  300: 1394,
  299: 1390,
  298: 1386,
  297: 1381,
  296: 1377,
  295: 1373,
  294: 1369,
  293: 1365,
  292: 1361,
  291: 1357,
  290: 1353,
  289: 1349,
  288: 1345,
  287: 1341,
  286: 1337,
  285: 1333,
  284: 1329,
  283: 1325,
  282: 1321,
  281: 1317,
  280: 1313,
  279: 1309,
  278: 1305,
  277: 1301,
  276: 1297,
  275: 1293,
  274: 1289,
  273: 1285,
  272: 1281,
  271: 1277,
  270: 1273,
  269: 1269,
  268: 1265,
  267: 1261,
  266: 1257,
  265: 1253,
  264: 1249,
  263: 1245,
  262: 1241,
  261: 1237,
  260: 1233,
  259: 1229,
  258: 1225,
  257: 1221,
  256: 1217,
  255: 1213,
  254: 1209,
  253: 1205,
  252: 1201,
  251: 1197,
  250: 1193,
  249: 1189,
  248: 1185,
  247: 1181,
  246: 1177,
  245: 1173,
  244: 1169,
  243: 1165,
  242: 1161,
  241: 1157,
  240: 1153,
  239: 1149,
  238: 1145,
  237: 1141,
  236: 1137,
  235: 1133,
  234: 1129,
  233: 1124,
  232: 1120,
  231: 1116,
  230: 1112,
  229: 1108,
  228: 1104,
  227: 1100,
  226: 1096,
  225: 1092,
  224: 1088,
  223: 1084,
  222: 1080,
  221: 1076,
  220: 1072,
  219: 1068,
  218: 1064,
  217: 1060,
  216: 1056,
  215: 1052,
  214: 1048,
  213: 1044,
  212: 1040,
  211: 1036,
  210: 1032,
  209: 1028,
  208: 1024,
  207: 1020,
  206: 1016,
  205: 1012,
  204: 1008,
  203: 1003,
  202: 999,
  201: 995,
  200: 991,
  199: 987,
  198: 983,
  197: 979,
  196: 975,
  195: 971,
  194: 967,
  193: 963,
  192: 959,
  191: 955,
  190: 951,
  189: 947,
  188: 943,
  187: 939,
  186: 935,
  185: 931,
  184: 927,
  183: 923,
  182: 919,
  181: 915,
  180: 910,
  179: 906,
  178: 902,
  177: 898,
  176: 894,
  175: 890,
  174: 886,
  173: 882,
  172: 878,
  171: 874,
  170: 870,
  169: 866,
  168: 862,
  167: 858,
  166: 854,
  165: 850,
  164: 846,
  163: 842,
  162: 838,
  161: 833,
  160: 829,
  159: 825,
  158: 821,
  157: 817,
  156: 813,
  155: 809,
  154: 805,
  153: 801,
  152: 797,
  151: 793,
  150: 789,
  149: 785,
  148: 781,
  147: 777,
  146: 773,
  145: 769,
  144: 764,
  143: 760,
  142: 756,
  141: 752,
  140: 748,
  139: 744,
  138: 740,
  137: 736,
  136: 732,
  135: 728,
  134: 724,
  133: 720,
  132: 716,
  131: 712,
  130: 708,
  129: 703,
  128: 699,
  127: 695,
  126: 691,
  125: 687,
  124: 683,
  123: 679,
  122: 675,
  121: 671,
  120: 667,
  119: 663,
  118: 659,
  117: 655,
  116: 651,
  115: 646,
  114: 642,
  113: 638,
  112: 634,
  111: 630,
  110: 626,
  109: 622,
  108: 618,
  107: 614,
  106: 610,
  105: 606,
  104: 602,
  103: 598,
  102: 593,
  101: 589,
  100: 585,
  99: 581,
  98: 577,
  97: 573,
  96: 569,
  95: 565,
  94: 561,
  93: 557,
  92: 553,
  91: 549,
  90: 544,
  89: 540,
  88: 536,
  87: 532,
  86: 528,
  85: 524,
  84: 520,
  83: 516,
  82: 512,
  81: 508,
  80: 504,
  79: 500,
  78: 495,
  77: 491,
  76: 487,
  75: 483,
  74: 479,
  73: 475,
  72: 471,
  71: 467,
  70: 463,
  69: 459,
  68: 455,
  67: 450,
  66: 446,
  65: 442,
  64: 438,
  63: 434,
  62: 430,
  61: 426,
  60: 422,
  59: 418,
  58: 414,
  57: 409,
  56: 405,
  55: 401,
  54: 397,
  53: 393,
  52: 389,
  51: 385,
  50: 381,
  49: 377,
  48: 373,
  47: 369,
  46: 364,
  45: 360,
  44: 356,
  43: 352,
  42: 348,
  41: 344,
  40: 340,
  39: 336,
  38: 332,
  37: 327,
  36: 323,
  35: 319,
  34: 315,
  33: 311,
  32: 307,
  31: 303,
  30: 299,
  29: 295,
  28: 291,
  27: 286,
  26: 282,
  25: 278,
  24: 274,
  23: 270,
  22: 266,
  21: 262,
  20: 258,
  19: 254,
  18: 249,
  17: 245,
  16: 241,
  15: 237,
  14: 233,
  13: 229,
  12: 225,
  11: 221,
  10: 216,
  9: 212,
  8: 208,
  7: 204,
  6: 200,
  5: 196,
  4: 192,
  3: 188,
  2: 184,
  1: 179,
};
